export const ENG = {
  RESTORE: {
    TITLE: 'Access Recovery',
    IIN_SUBTITLE: 'Enter the TIN provided during online banking registration',
    PHONE_SUBTITLE: 'Enter the phone number provided during online banking registration',
  },
  AUTH: {
    LOGIN_TITLE: 'Login',
    LOGIN_SUBTITLE: 'to business internet banking',
    REGISTER: 'Register',
    LOGIN: 'Log in',
    SET_PASSWORD: 'Set Password',
    LOGIN_OB_BROWSER: 'to log into Optima Business via browser',
    UNEXPECTED_ERROR: 'Unexpected system error. Please try again later.',
    NOT_FOUND_COMPANY: 'There is no information about the companies',
    CHECK: {
      CAPSLOCK: 'Caps Lock is on',
      LANGUAGE: 'Check the input language',
      CAPSLOCK_AND_LANGUAGE: 'Check input language and Caps Lock',
    },
    PASSWORD: {
      TITLE: 'Password',
    },
    INVALID: 'Invalid client ID or password',
    ENTER_ID: 'Enter client ID',
    ENTER_PASSWORD: 'Enter password',
    CODE: {
      SEND_NEW: 'Get a new code',
    },
    TOTP_CODE: {
      ERROR: 'Invalid TOTP code. Please try again.',
    },
    LOCK: {
      DATA_VERIFICATION: 'Please wait while we verify your data',
      DATA_VERIFICATION_LABEL: 'If everything is in order, this section will be available after verification',
    },
  },
  PERSONAL_QR: {
    TITLE: 'Personal QR',
    SOON: {
      TITLE: 'A personal QR code will appear here soon',
      TEXT: 'You will be able to create QR codes for each client indicating the purpose of the payment - for what, for whom and for what amount',
    },
  },
  RESET_PASSWORD: {
    TITLE: 'Password Reset',
    SUB_TITLE: 'to log into Optima Business',
    PHONE: 'Enter your phone number',
    FINISH: {
      TITLE: 'Your password has been reset!',
      SUB_TITLE: 'A one-time password has been sent to your phone number to log in and set a new password',
    },
    SMS_CODE: {
      CONFIRMATION: 'SMS Confirmation',
      ENTER: 'Enter the code from the SMS sent to your phone number',
      GET_NEW: 'You can get a new code in {countdown} sec',
      OUTDATED: 'The SMS code has expired',
      REQUEST: 'Request a new code to your phone number',
    },
  },
  HELP: {
    TITLE: 'Help',
    CONTACTS: 'Contacts',
    CALL_CENTRE: 'Call Center',
    CALL_NUMBER: 'Call the number',
    CHAT_SUPPORT: 'Chat Support',
    WRITE_WHATSAPP: 'Message on WhatsApp',
    USER_MANUAL: 'Authorization Guide',
  },
  SESSION: {
    CONTINUE: 'Do you want to continue the session?',
    EXPIRE: 'Your session will expire in',
  },
  DIRECTORY: {
    DICTIONARY: 'Directory',
  },
  INFORMATION: {
    PHONE: 'Phone number',
    PHONES: 'Phone numbers',
    PARTY_ID: 'Client ID',
  },
  CITY: 'Bishkek',
  DIALOG: {
    TO_MAIN: 'To main page',
    RETURN: 'Return',
    TRY_AGAIN: 'Try again',
    RETURN_HISTORY: 'Return to history',
    TO_PAYMENT_CREATE: 'To create transactions',
    SAVE_TEMPLATES: 'Save as templates',
    EXIT: 'Exit',
    CANCEL: 'Cancel',
  },
  SHARED: {
    SOON: {
      TITLE: 'Coming soon',
      SUB_TITLE: 'Please wait',
    },
    NOT_ENOUGH_CHARACTERS: 'Not enough characters',
    COMMISSION: 'Commission',
    TOTAL: 'Total',
    AMOUNT_FROM: 'Amount from',
    MOUNT_TO: 'Amount to',
    DATE_FROM: 'Date from',
    DATE_TO: 'Date to',
    TIME_FROM: 'Time from',
    TIME_TO: 'Time to',
    TIME: 'Time',
    ALL: 'All',
    COMMISSION_BANK: 'Bank commission',
    INTERFACE_LANG: 'Interface language',
    DATETIME: 'Date and time',
    OPERATION_HISTORY: 'Operations history',
    OPERATIONS: 'Operations',
    NO_DATA: 'no data',
    ACTION: {
      CHOOSE: 'Choose',
      ACCEPT: 'Accept',
      RETURN: 'Return',
      EDIT: 'Edit',
      CHANGE: 'Change',
      OK: 'OK',
      YES: 'Yes',
      NO: 'No',
      ICON_PDF: 'Download PDF',
      CONFIRM: 'Confirm',
      CREATE: 'Create',
      RECREATE: 'Re-create',
      IMPORT: 'Import',
      CLOSE: 'Close',
      APPLY: 'Apply',
      RESET: 'Reset',
      RETRY: 'Refresh',
      ACCESSIBLY: 'Got it',
      CONTINUE: 'Continue',
      CANCEL: 'Cancel',
      EXIT: 'Exit',
      OPEN: 'Open',
      FORGOT_PASSWORD: 'Forgot password?',
      CANCELED: 'Cancel',
      ADD: 'Add',
      LOOK: 'View',
      DOWNLOAD: 'Download',
      BACK: 'Back',
      DELETE: 'Delete',
      REPEAT: 'Repeat',
      REVOKE: 'Reject',
      SIGN: 'Sign',
      FOR_SIGN: 'For signing',
      SAVED: 'Save',
      NEXT: 'Next',
      DONE: 'Done',
      SWITCH: {
        ON: 'On',
        OFF: 'Off',
      },
      CHOOSE_TEMPLATE: 'Choose from templates',
      WRITE_OFF: 'Write off',
      SAVE_TEMPLATE: 'Save template',
      ENROLL: 'Enroll',
      RELOAD: 'Reload',
      GOOD: 'Okay',
      COPY: 'Data copied',
      COPY_ACTION: 'Copy',
      PAYMENTS: 'Payments',
    },
    COMMENT: 'Comment',
    OUTGOING: 'Outgoing',
    INCOMING: 'Incoming',
    REQUISITE: 'Requisite',
    RECEIPT_NUMBER: 'Remitter’s receipt number',
    SENDER_ACCOUNT: "Sender's account",
    AMOUNT_AFTER_COMMISSION: 'Amount with commission',
    ABOUT_PAYMENT: 'About payment',
    FOUND: 'Found',
    ENROLLMENT_ACCOUNT: 'Enrollment account',
    CHANGES_SAVED: 'Changes saved',
    READY: 'Done!',
    CREATED: 'Created',
    AGREE_FOR_CONTINUE: 'To continue, confirm the information below',
    SORTING: 'Sorting',
    FULL_NAME: 'Full Name',
    CREATED_DATE: 'Сreation date',
    CITY: 'City',
    ADDRESS: 'Address',
    ACTUAL_ADDRESS: 'Actual Address',
    PCS: 'pcs',
    MAIN: 'Main',
    PHOTO: 'Photo',
    BACK: 'Back',
    ACCOUNT_NUMBER: 'Account Number',
    DOWNLOAD: 'Download',
    DEPOSITS: 'Deposits',
    INFORMATION: 'Information',
    GENERAL: 'General',
    SECURITY: 'Security',
    USER_ACCOUNT: 'User Account',
    STATUS: 'Status',
    NUMBER: 'Number',
    NUMBER_SYMBOL: '№',
    TYPE: 'Type',
    EXIT: 'Exit',
    CREATE: 'Create',
    PRODUCTS: 'Products',
    LOOK: 'View',
    SEE_ALL: 'View All',
    IMPORT: 'Import',
    RETRY: 'Refresh',
    CONTINUE: 'Continue',
    CANCEL: 'Cancel',
    CANCELED: 'Cancel',
    CONFIRM: 'Confirm',
    PHONE: 'Phone',
    INN: 'TIN',
    REGION: 'Region',
    AIYL_AREA: 'Aiyl Aimak',
    KBK: 'Budget Classification Code',
    PASSWORD: 'Password',
    ACCOUNT_PASSWORD: 'Account password',
    DONE: 'Done',
    FORGOT_PASSWORD: 'Forgot password?',
    CONTRACT: 'Contract',
    REMAINDER: 'Balance',
    YES: 'Yes',
    NO: 'No',
    OK: 'OK',
    CURRENCY: 'Currency',
    DOCUMENT_NUMBER: 'Document number',
    SUM: 'Sum',
    RATE: 'Rate',
    FILTER: {
      TITLE: 'Filter',
      SEARCH: 'Search',
      APPLY: 'Apply',
      RESET: 'Reset',
    },
    TOTP: {
      CODE: 'TOTP Code',
      ENTER_CODE: 'Enter generated TOTP code',
      INVALID_TOTP: 'Invalid TOTP code. Please try again.',
    },
    SWITCH: {
      ON: 'On',
      OFF: 'Off',
    },
    SAVE: {
      SAVED: 'Save',
      SUCCESSFUL: 'Successfully saved',
      CHANGES: 'Save changes',
    },
    SMS: {
      TITLE: 'SMS',
    },
    SIGN_TYPE: {
      ONE_SIGNATORY: 'One signatory',
      TWO_SIGNATORY: 'Two signatories',
    },
    SIGN_RIGHT: {
      AUDITOR: 'Auditor',
      CREATOR: 'Creator',
      FIRST: '1st signature',
      SECOND: '2nd signature',
      THIRD: '3rd signature',
      NONE: 'No signature',
      CASH_MANAGER: 'Manager',
      CASHIER: 'Cashier',
    },
    ERROR_PLACEHOLDER: {
      SUBTITLE: 'Try refreshing the page',
      TITLE: 'Server error',
    },
    SYSTEM_ERROR: 'Unexpected system error. Please try again later.',
    ACCOUNT: {
      TITLE: 'My products',
      RKO: 'Account',
      CARD: 'Card',
      DEPOSIT: 'Deposit',
      SETTLEMENT_ACCOUNTS: 'Accounts',
      CARDS: 'Cards',
    },
    RULE: {
      FILL_FIELD: 'Fill in the field!',
      FILL_LATIN: 'Fill in the field in Latin characters!',
      NEW_OLD_PASSWORD_REPEATED: 'New password must be different from the current one.',
      CONVERSION_AMOUNT_EXCEEDS_BALANCE: 'Conversion amount exceeds available account balance-cards',
      PAYMENT_AMOUNT_EXCEEDS_BALANCE: 'Payment amount exceeds available account balance',
      ACCOUNT_INSUFFICIENT_FUNDS: 'Insufficient funds in the account',
      INCORRECT_DATE: 'Incorrect date',
      INCORRECT_TIME: 'Incorrect time',
      INCORRECT_SYMBOLS: 'Invalid characters {value}',
      INCORRECT_MANUAL_RATE: 'Incorrect manual rate',
      INCORRECT_PERCENTAGE_DIFFERENCE: 'Invalid value!',
      NO_ACCESS_OPERATION: 'No access to operation!',
      FORBIDDEN_SEND_EXTERNAL_ACCOUNT: 'Forbidden to send to external accounts',
      SAME_DEBIT_ACCOUNT: 'The same as debit account',
      TIME_EXPIRED: 'Time limit exceeded. Operation unavailable.',
      PAY_CONTROL_NOT_EXIST:
        'Rutoken or TOTP signing is not available in the mobile app. Please sign the operation on the website',
      PAY_CONTROL_NOT_AVAILABLE: 'Unable to send payment for signing. One of the signatories lacks PayControl.',
      INCORRECT_INN: 'Invalid TIN',
      INCORRECT_DATA: 'Invalid data',
      INCORRECT_PASSWORD: 'Invalid password',
      ONE_YEAR_PERIOD: 'You can select a period of up to 1 year only',
      MONTH_PERIOD: 'You can select a period of up to 31 days only',
      MAX_LENGTH: 'Maximum input length is {length} characters',
      MIN_LENGTH: 'Minimum input length is {length} characters',
      CLIENT_NOT_FOUND: 'Client not found. Please check the entered data',
      IBAN: 'The account structure does not comply with the IBAN standard',
      OUTLET_CHECK: 'Only letters, numbers, spaces, and dashes are allowed',
      NOT_EMOJI: 'Emojis are not acceptable',
    },
    SEARCH: 'Search',
    TIME_LIMIT: 'You can create a payment from {timeFrom} to {timeTo}',
    VALUE_DATE: 'Value date',
    AMOUNT_PAYMENT: 'Payment amount',
    ACCOUNT_NOT_FOUND: 'Account was not found!',
    CHOOSE_TEMPLATE: 'Choose from templates',
    NAME_LEGAL_ENTITY: 'Name of payer',
    WITHDRAWAL_ACCOUNT: 'Debited account',
    RECIPIENT: 'Recipient',
    RECIPIENT_NAME: 'Recipient name',
    APPOINTMENT: 'Appointment',
    TYPE_TRANSACTION: 'Transaction type',
    ENROLL: 'Enroll',
    WRITE_OFF: 'Write off',
    PAYMENT_CODE: 'Payment code',
    SAVE_TEMPLATE: 'Save template',
    NAME: 'Name',
    PAYMENT_DETAILS: 'Payment details',
    OPERATION_DETAILS: 'Transaction details',
    INVOICE_COMMISSION_PAYMENT: 'Invoice for commission payment',
    PAYER: 'Payer',
    CLOSE: 'Close',
    BIN: 'BIN',
    KPP: 'KPP',
    BIC_SWIFT: 'BIC/SWIFT',
    BIC_SWIFT_INTERMEDIARY: 'BIC/SWIFT of intermediary bank',
    NOT_FOUND: 'Data not found',
    MORE: 'more',
    LESS: 'less',
    DETAILED_INFO_BY_CALL_CENTER: 'You can get more detailed information through the bank’s contact center at 9500',
    WEEK: {
      MON: 'Mon',
      TUE: 'Tue',
      WED: 'Wed',
      THU: 'Thu',
      FRI: 'Fri',
      SAT: 'Sat',
      SUN: 'Sun',
    },
    CONFIRM_CLOSE_TITLE: 'Want to exit?',
    CONFIRM_EXIT_TITLE: 'Are you sure you want to exit?',
    NOT_HAVE_PRODUCTS: 'You don’t have any products in Optima Business yet',
  },
  CALCULATOR: {
    CURRENCY_CONVERTOR: 'Currency Calculator',
    TYPE_RATE: 'Type of Rates',
  },
  FORM_PAYMENT: {
    NOT_ENOUGH_MONEY: 'Not enough money on the account',
    NOT_ENOUGH_MONEY_DESCRIPTION:
      'Planned balance: {plannedBalance} {currency}.\nEnter a different amount or top up the account.',
    NOT_ENOUGH_MONEY_BUTTON: 'I’ll enter a different amount',
    INSUFFICIENT_FUNDS_DIALOG: {
      SINGLE_PAYMENT_TITLE: 'Insufficient funds to send the payment for signing',
      PAYMENT_AMOUNT: 'Payment amount:',
      AVAILABLE_BALANCE: 'Available balance:',
      DESCRIPTION: 'You can edit the payment or continue sending it for signing',
      EDIT: 'Edit',
      CONTINUE: 'Continue',
    },
    PAYMENTS_FOR_SIGNATURE: 'Payments for signature',
    CONVERSION: {
      PURCHASE: 'Set purchase rate',
      CONTRACTUAL_PURCHASE: 'Negotiated purchase rate',
      SALES: 'Set sale rate',
      CONTRACTUAL_SALES: 'Negotiated selling rate',
      CONVERSION: 'Set conversion rate',
      CONTRACTUAL_CONVERSION: 'Negotiated conversion rate ',
      ENROLLMENT_ACCOUNT: 'Proceeds account',
      DIDNT_LOAD: 'Rate was not loaded.<br/>Please update conversion rate',
      RESET_VALUE_RATE: 'Return to set one',
      TEXT_INFO_CONVERSION: 'If the amount is more than 10 000 USD, you can set a contract rate',
    },
    TRANSFER: {
      PAYMENT_CODE: {
        LABEL: 'Payment code',
        HINT: 'Select the code that corresponds to purpose. Search is made by code and name',
      },
      PAYING_GOODS_SERVICES:
        'When paying for goods/services, specify the name of goods, works, services, contract/invoice numbers and dates',
      BIC_BANK_NAME: 'BIC/Bank name',
      NAME_RECIPIENT: 'Recipient name',
      NOT_OPERATION_TYPE: 'Select the type of operation',
      AVAILABLE_UNTIL: 'Available from {timeFrom} to {timeTo}',
      MAX_AMOUNT_ONE_MILLION: ' Maximum amount up to KGS 1 million ',
      FORBIDDEN_SYMBOL: '& is a forbidden symbol.',
      INTRABANK_RKO_TO_CARD_NOT_ALLOWED: 'The account is a card account. Please enter the current account.',
      ACCOUNT_NOT_EXIST_FOR_OPERATION:
        'This type of operation "{operation}" is not available for the selected debit account. Please contact the first signatory to gain access.',
    },
    SWIFT: {
      COUNTRY: 'Country',
      CORRESPONDENT_ACCOUNT: 'Correspondent account',
      NAME: 'Name',
      ACCOUNT_IBAN: 'Account/IBAN',
      CURRENCY_TRANSACTION_CODE: 'Currency transaction code (VO)',
      INTERMEDIARY_BANK: 'Intermediary bank',
      EXOTIC_CURRENCY: 'Exotic currency',
      AVAILABLE_DEBIT_ACCOUNT_IS_EURO: 'Available if debit account currency is Euro',
      CROSS_RATE: 'Cross-rate',
      PAYMENT_CODE: {
        LABEL: 'Payment code',
        HINT: 'Choose a code that matches the purpose. Search is performed by code and name',
      },
      CARGO:
        'I undertake to provide Optima Bank OJSC an official document confirming delivery of goods to the Kyrgyz Republic under this transfer within 3 (three) working days after the delivery of goods (for goods-related transfers)',
      TRANSFER_BETWEEN_BANKS: 'Transfers between banks in KR must include the intermediary bank',
      RUS_USD_EUR_NOT_ALLOWED:
        'Transfers to the Russian Federation in US dollars (USD) and euros (EUR) are temporarily unavailable',
      RUS_USD_EUR_WARNING:
        'Dear clients, SWIFT transfers to the Russian Federation in USD and EUR are temporarily unavailable. For alternative settlement options, please contact a Bank branch',
      HINT_NAME: 'Enter your "Address" and "City" only in the appropriate fields above!',
    },
    O24_TRANSFER: {
      BY_PHONE_NUMBER: 'By phone number',
      BY_CARD_NUMBER: 'By account number',
    },
    LOADING: {
      DRAFT: 'Payment is saved as a draft',
      SIGNED: 'Payment is sent for signature',
    },
    LIMITS: {
      ONE_TIME: 'You have exceeded the one-time limit!',
      DAILY: 'You have exceeded the daily limit!',
      MONTHLY: 'You have exceeded the monthly limit!',
      FOR_DAY: 'You have exceeded the daily limit!',
      FOR_MONTH: 'You have exceeded the monthly limit!',
    },
    REMOTELY_IDENTIFIED_EXCEPTION: {
      MONTHLY: {
        TITLE: 'The limit for transfers per month has been exhausted',
        SUBTITLE: 'Confirm the account at the bank office to remove restrictions',
      },
      FOR_MONTH: {
        TITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.MONTHLY.TITLE',
        SUBTITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.MONTHLY.SUBTITLE',
      },
      ONE_TIME: {
        TITLE: 'Transfer amount is too large',
        SUBTITLE: 'Try entering a smaller amount or confirm the account at the bank office to remove the restrictions',
      },
      OPERATION_NOT_AVAILABLE: {
        TITLE: 'You can only transfer to your own cards',
        SUBTITLE: 'Confirm the account at the bank office to remove restrictions',
      },
      DAILY: {
        TITLE: 'Limit exhausted',
        SUBTITLE: 'You have exceeded the limit for a day!',
      },
      FOR_DAY: {
        TITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.DAILY.TITLE',
        SUBTITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.DAILY.SUBTITLE',
      },
    },
    CONFIRM_TRANSFER: {
      TITLE: 'Confirm the transfer',
      DESCRIPTION: 'The exchange rate is preliminary and may change during calculation',
      TRANSFER_AMOUNT: 'Transfer amount',
      CREDITED_AMOUNT: 'Will be deposited',
      CONVERSION_RATE: 'Conversion rate',
    },
    EDITING: 'Payment editing',
  },
  PAYMENT_DETAILS: {
    VALUE_DATE: 'Value date',
    DOCUMENT: 'Document №',
    WRITE_OFF_AMOUNT: 'Debit amount',
    RATE_OPERATION: 'Operation rate',
    CREATED: 'Created',
    ENROLLMENT_AMOUNT: 'Enrollment amount',
    BANK: 'Bank',
    BIC: 'BIC',
    ACCOUNT: 'Account',
    CARD_ACCOUNT: 'Card account',
    CARD_NUM: 'Card number',
    KBK: 'KBK',
    PURPOSE: 'Appointment',
    CORPORATE_ACCOUNT: 'Correspondent account',
    RECIPIENT_COUNTRY: 'Recipient country',
    COMMISSION: 'Commission',
    COMMISSION_CURRENCY: 'Commission currency',
    COMMISSION_ACCOUNT: 'Commission account',
    PAYMENT_CODE: 'Payment code',
    OPERATION_ID: 'Operation ID',
    EXOTIC_RATE: 'Exotic rate (excluding USD, EUR, RUB, CNY, KZT, GBP, CNY, JPY)',
    OPTION: 'Option',
  },
  PASSWORD_WITH_REPEAT: {
    THINK_UP_PASSWORD: 'New password',
    REPEAT_PASSWORD: 'Repeat new password',
    PASSWORD_MISMATCH: 'Passwords do not match',
  },
  REVOCATION_REASON_PAYMENT: {
    REASON_FOR_RECALL: 'Reason for revocation',
    ENTER_REASON: 'Enter the reason',
  },
  SELECTION_PAYMENT_HEADER: {
    SELECT_ALL: 'Select all',
    OPERATIONS: 'Operations',
    FOR_AMOUNT: 'For amount',
    OPERATION: 'operation',
  },
  VISIBLE_ACCOUNT_LIST: {
    MISSING_ACCOUNT: 'No accounts available',
    ACCOUNT_VISIBILITY: 'Account visibility',
  },
  PAYMENT_ACTION: {
    MB_TRANSFER_SOM: 'Interbank transfer in KGS',
    MB_TRANSFER: 'Interbank transfer in foreign currency',
    CONVERSION: 'Conversion',
    INTRABANK_TRANSFER: 'Intrabank transfer',
    OWN_CARD_TRANSFER: 'Transfer to Business Card',
    O24_TRANSFER: 'Transfer to Optima24',
    CARD_RKO_TRANSFER: 'Transfer from Business Card to settlement account',
    TRANSFER_BY_INVOICE: 'Invoice payment',
    NOT_ALLOWED_BY_SIGN_RIGHT: 'Your role does not allow you to create payments',
  },
  BUDGET: {
    TITLE: 'Budget payments',
    DATE_EXPIRED:
      'Creating an operation with the current value date is not available. Would you like to create it for the next working day - {date}?',
    GNS: {
      TITLE: 'Tax payments to STS',
      OTHER_TAX: 'Payment of other taxes',
      CHATTEL_TAX: 'Payment of movable property tax',
      REALTY_TAX: 'Payment of real estate tax',
      PAYMENT: 'Payment by payment code',
    },
    TUNDUK: {
      TITLE: 'Payment for GPEU Tunduk services',
    },
    AIS_FOREST_USE: 'AIS "Forest Management"',
    GUARANTEE_FEE_ETP_FUGI: 'Security deposit (ETP SPMF)',
    E_PATENT: 'Electronic patent',
    GUARANTEE_FEE_ETP_MSU: 'Payment of security deposit (ETP LSG)',
    SOCIAL_INSURANCE_PAYMENT: 'Payment for social insurance',
    INSURANCE_CONTRIBUTION_PAYMENT_BY_CODE: 'Insurance contribution payment by payment code',
    ELECTRONIC_NOTARY: 'Electronic notary',
    BUDGET_CREDIT_REPAYMENT: 'Repayment of budget loans',
    JUDICIAL_DEPARTMENT_GUARANTEE_FEE:
      'Judicial Department under the Supreme Court – security deposit for participation in auctions',
    JUDICIAL_DEPARTMENT_PROPERTY_PAYMENT: 'Judicial Department under the Supreme Court – payment for property value',
    JUDICIAL_DEPARTMENT_ENFORCEMENT_FEE_10_PERCENT: 'Judicial Department – payment of 10% enforcement fee',
    DEADLINE_HINT:
      'From the moment you start filling out, make and sign the payment within the next 15 minutes. If you do not sign on time, the payment will not be processed',
    SOON: 'Coming soon!',
    PLEASE_WAIT: 'Please wait',
    FORM: {
      INPUT_REGION: 'Select a district',
      INPUT_TAX_TYPE: 'Select tax type',
      INPUT_AMOUNT_PAYMENT: 'Enter amount',
      INPUT_AIYL_AREA: 'Select Aiyl Aimak',
      INPUT_WRITE_OFF: 'Debit account',
      AMOUNT_PAYMENT: 'Payment amount',
      TAX_TYPE: 'Tax type',
      TAX_SUM: 'Tax amount',
      ENICODE: 'Enicode',
      COEFFICIENT_FUNC_PURPOSE: 'Functional purpose coefficient',
      BOOK_VALUE: 'Book value',
      PERSONAL_ACCOUNT: 'Personal account',
      CODE_PAYMENT: 'Payment code',
    },
    MAX_AMOUNT: 'Maximum amount {value}',
    MIN_AMOUNT: 'Minimum amount {value}',
    PAYMENT_DEADLINE: 'The payment code is valid only on the day of creation — until 23:59:59.',
    PAYMENT_DEADLINE_ERROR:
      'Enter a valid payment code. Note that the code works only on the day of creation — until 23:59.',
  },
  FOOTER: {
    COPYRIGHT: 'Optima Bank OJSC',
    YEARS: '© 1992–{year}',
  },
  LANGUAGE: {
    RU: 'Russian',
    KG: 'Kyrgyz',
    ENG: 'English',
  },
  HOME: {
    TITLE: 'Home',
  },
  HISTORY: {
    TITLE: 'My operations',
    STATUS: {
      CREATION: 'Creation',
      DRAFT: 'Draft',
      TO_DRAFT: 'To draft',
      PARTIALLY_CONFIRMED: 'To be signed',
      PARTIALLY_CONFIRMED_SUFFIX: 'For you to sign',
      PARTIALLY_CONFIRMED_CANCELED: 'For you to cancel',
      ON_VERIFICATION: 'To be signed',
      ON_VERIFICATION_SUFFIX: 'For you to sign',
      ON_VERIFICATION_CANCELED: 'For you to cancel',
      PARTIAL_CONFIRMATION_COMPLETED: 'Signed by 2nd',
      PARTIAL_CONFIRMATION_COMPLETED_SUFFIX: 'Signed by 2nd',
      ON_VERIFICATION_COMPLETED: 'Signed by 1st',
      ON_VERIFICATION_COMPLETED_SUFFIX: 'Signed by 1st',
      CANCELED_SIGN_TWO: 'Canceled by 2nd',
      CANCELED_SIGN_ONE: 'Canceled by 1st',
      FOR_EDITING: 'Sent for editing',
      REJECTED_SUFFIX: 'For you to edit',
      CONFIRMED: 'Signed',
      REVOKE: 'Revoked',
      WAIT_RESPONSE_FROM_BANK: 'In processing',
      CHECK_STATUS_BANK: 'Checking of Bank response',
      PAYMENT_REQUEST_TO_BANK: 'Sending to the Bank',
      KVIT: 'Executed by the Bank',
      SUCCESS: 'Completed',
      ERROR: 'Rejected by Bank',
      UNKNOWN: 'Invalid status',
      FIRST_SIGN_IN_PAY_CONTROL: 'To be sent for signature',
      FIRST_SIGN_IN_PAY_CONTROL_COMPLETE: 'To be signed',
      FIRST_SIGN_IN_PAY_CONTROL_COMPLETE_SUFFIX: 'For you to sign',
      SECOND_SIGN_IN_PAY_CONTROL: 'To be sent for signature',
      SECOND_SIGN_IN_PAY_CONTROL_COMPLETE: 'To be signed',
      SECOND_SIGN_IN_PAY_CONTROL_COMPLETE_SUFFIX: 'For you to sign',
      TIMEOUT_CANCELED_SIGN_TWO: 'Timeout cancellation',
      TIMEOUT_CANCELED_SIGN_ONE: 'Timeout cancellation',
      PARTIALLY_EXECUTED: 'Partially executed',
      TIME_IS_OUT: {
        TITLE: 'Denied after time has expired',
        ERROR: 'Payment did not pass the time check, please try again',
      },
    },
    STATUS_HISTORY: {
      DRAFT: 'Created',
      PARTIAL_CONFIRMATION_COMPLETED: 'Signed by 2nd signer',
      ON_VERIFICATION_COMPLETED: 'Signed',
      ON_VERIFICATION_COMPLETED_SUFFIX: 'Signed by 1st signer',
      CANCELED_SIGN_TWO: 'Canceled by 2nd signer',
      CANCELED_SIGN_ONE: 'Canceled by 1st signer',
      WAIT_RESPONSE_FROM_BANK: 'Processing',
      PAYMENT_REQUEST_TO_BANK: 'Execution request',
      TIMEOUT_CANCELED_SIGN_TWO: 'Timed out (2nd signer)',
      TIMEOUT_CANCELED_SIGN_ONE: 'Timed out (1st signer)',
      REVOKE: 'Revoked',
      KVIT: 'Executed by bank',
      SUCCESS: 'Completed',
      ERROR: 'Rejected',
    },
    LISTS: {
      ALL: 'All',
      DRAFT: 'My drafts',
      FAILED: 'Rejected',
      DRAFT_SALARY: 'Ready to sign',
      ERROR: 'Canceled by Bank',
      FOR_SIGN: 'To be signed',
      FOR_EDITING: 'To be edited',
      SUCCESS: 'Executed',
    },
    NOTIFICATIONS: {
      SIGNED: {
        SUCCESS: 'Payment {number} signed',
        SUCCESS_MULTIPLE: 'Payments signed',
        SUCCESS_PARTIAL: 'Payments partially signed',
        ERROR: 'Failed to sign payment',
        ERROR_MULTIPLE: 'Failed to sign payments',
      },
      SEND_TO_SIGNED: {
        SUCCESS: 'Payment {number} sent for signature',
        SUCCESS_MULTIPLE: 'Payments sent for signature',
        ERROR: 'Failed to send payment for signature',
        ERROR_AFTER_DRAFT: 'The operation was created as a draft and must be signed from the transaction history',
        ERROR_MULTIPLE: 'Failed to send payments for signature',
      },
      SAVED_TO_DRAFT: {
        SUCCESS: 'Payment {number} saved as draft',
        ERROR: 'Failed to save payment as draft',
      },
      DELETE_DRAFT: {
        SUCCESS: 'Draft {number} deleted',
        ERROR: 'Failed to delete draft',
      },
      FOR_EDITING: {
        SUCCESS: 'Payment {number} rejected',
        ERROR: 'Failed to reject payment',
      },
      SEND_TO_EDITING: {
        SUCCESS: 'Payment {number} sent for editing',
        ERROR: 'Failed to send payment for editing',
      },
      SUCCESS_EDITING: {
        SUCCESS: 'Payment successfully edited',
        ERROR: 'Failed to edit payment',
      },
    },
    TRANSACTION: {
      PAYMENTS_SIGNED: 'Signing payments...',
      PAYMENT_SIGNED: 'Signing payment No. {number}...',
      PAYMENT_CANCELLED: 'Cancelling payment No. {number}...',
      PAYMENT_SENT_EDITING: 'Sending payment No. {number} for editing...',
      PAYMENT_SENT_SIGNING: 'Sending payment No. {number} for signature...',
      FILE_DOWNLOADING: 'Downloading file...',
      FILE_OPENING: 'Opening file...',
      PAYMENT_REMOVING: 'Removing payment No. {number}...',
      PAYMENT_SENT_SIGN: 'Sending payment for signature...',
      PAYMENTS_SENT_SIGN: 'Sending payments for signature...',
      PAYMENTS_RESPOND: 'Recalling payments...',
      PAYMENT_RESPOND: 'Recalling payment...',
      PAYMENT_UPDATING: 'Updating payment No. {number}...',
      PAYMENT_RECALL: 'Payment recalled for editing',
      PAYMENT_RECALLING: 'Recalling payment...',
      ERROR: {
        FOR_SIGN: 'Failed to send for signature',
        PAYMENT_RECALL: 'Failed to recall payment',
      },
    },
  },
  FILE_UPLOAD: {
    LOADING: 'Uploading a file...',
    FILE_SIZE_EXCEPTION: 'File size exceeds allowed value.',
    FILE_EXTENSION_EXCEPTION: 'File extension does not match expected value.',
    FILE_SAVED_SUCCESSFULLY: 'File saved successfully',
    IN_IMPORTED: 'In imported',
    FAILED_SAVE_FILE: 'File saving failed',
  },
  HISTORY_PAYMENT_QR: {
    EXTRACT_FORMAT: 'Select format',
    DOWNLOAD_STATEMENT: 'Download the extract',
    TITLE: 'QR Code Payments',
    EXTRACT_EXCEL: 'Export to Excel',
    VALIDATION_ERROR_DATE: 'Please specify both dates or a time period in the filters to export to Excel',
    ENROLLED: 'Credited',
    TYPE_TRANSACTION: 'Transaction Type',
    TYPE_QR_POS: 'QR Type and POS Terminal Number',
    POS_NUMBER: 'POS Terminal Number',
    QR_SERVICE_TYPE: {
      STATIC: 'Static',
      DYNAMIC: 'Dynamic',
      OVERHEAD: 'Payment by invoice',
      WEB: 'Online payment',
      MONITOR: 'Offline payment at the cash desk',
      INVOICE: 'Invoice for payment',
      PERSONAL_QR_WEB: 'Personal QR',
      DEEPLINK_QR: 'Deeplink QR',
    },
    STATUS_SUCCESS: 'Executed',
    PAYMENT_FOR_OPTIMA_QR: 'Payment via OptimaQR from {senderName}',
    PAYMENT_FOR_QR: 'Payment via QR Code',
    EMPTY_HISTORY: 'No transactions found',
    SORTED: {
      TITLE: 'Sort by Amount',
      NONE: 'No sorting',
      ASC: 'Ascending',
      DESC: 'Descending',
    },
    DATE_PERIOD: {
      RECENT: 'Recent',
      WEEK: 'Last 7 days',
      MONTH: 'Last 30 days',
    },
    INCOME_TODAY: 'Income Today',
    INCOME_YESTERDAY: 'Income Yesterday',
    SALES_SHORT_LABEL: 'Number of Sales',
  },
  QR_REFUND: {
    ABOUT: 'About the refund',
    OUTLET_NAME_OR_ACCOUNT: 'Point name',
    OUTLET_ADDRESS: 'Point address',
    RETURNED: 'Returned',
    TO_RETURN: 'To the return',
    TO_CLIENT: 'Return to client',
    TO_CARD: 'Return to card',
    TO_REFUND_CHECK: 'Return check',
    CHECK_NUMBER: 'Check number',
    RETURN_CHECK_NUMBER: 'Return receipt number',
    SUM: 'Refund amount',
    PURPOSE: 'Reason for return',
    HINT: 'You can make no more than one full or partial refund',
    ONLY_O24: 'OptimaQR refunds only',
    ALREADY_RETURNED: 'A refund has already been made for this payment',
    IN_PROCESS: 'The return has already been sent for signature',
    RULES: {
      AMOUNT: 'The refund amount cannot be greater than the original payment amount',
      PURPOSE: 'You can enter from 4 to 140 characters and all special characters except these: \\ «» & <>',
    },
    ERRORS: {
      PAYER_ACCOUNT_NOT_ENOUGH_MONEY: 'Not enough money in the debit account',
      PAYER_ACCOUNT_NOT_ENOUGH_MONEY_HINT: 'Refill your account and try the refund again',
      PAYER_ACCOUNT_BLOCKED: 'Write-off account blocked',
      PAYER_ACCOUNT_BLOCKED_HINT: 'If you are the owner, please contact the office {department} to unblock the account',
      RECIPIENT_ACCOUNT_BLOCKED: 'Enrollment account is inactive',
      RECIPIENT_ACCOUNT_BLOCKED_HINT: 'Ask the client contact to support to activate the account',
      RECIPIENT_ACCOUNT_INACTIVE: 'Write-off account inactive',
    },
  },
  QR_PAYMENT: {
    TITLE: 'QR code payment',
    SUBTITLE: 'QR payment',
    B2C_O24: 'B2C Payment via OptimaQR',
    B2B_O24: 'B2B Payment via OptimaQR',
    B2B_ELQR: 'B2B Payment via ELQR',
    B2G: 'B2G payment',
  },
  SETTINGS: {
    TITLE: 'Settings',
    MAIN: {
      PAY_CONTROL: 'Pay Control',
      VISIBILITY_ACCOUNT: 'Account Visibility',
      CHANGE_PHONE: 'Change phone Number',
      CODE_WORD: 'Code word',
      COMPANY: {
        TITLE: 'About the Company',
        ID_COMPANY: 'Company ID',
        NAME: 'Company Name',
        SIGN_TYPE: 'Signature Type',
        SIGN_SCHEME: 'Payment Routing',
        DEPARTMENT_NAME: 'Contract Branch',
        REGISTER_DATE: 'Contract Registration Date',
      },
      PRIVATE: {
        TITLE: 'Personal Information',
        NAME: 'Full Name',
        RIGHTS: 'Role',
        EMAIL: 'Email',
        PHONE: 'Phone Number',
      },
      CONTACTS: {
        TITLE: 'Bank Contacts',
        WHATS_APP: 'WhatsApp',
        PHONE: 'Phone',
        EMAIL: 'E-mail',
      },
      PAYMENT: {
        TITLE: 'Operation Time Regulations',
        SUBTITLE: 'Time restrictions for transactions in Optima Business:',
        DESCRIPTION:
          'Please pay attention to the specified time frames when performing operations in Optima Business. Adhering to these limits will help avoid potential delays in processing.',
        TYPE: {
          CLEARING: 'Clearing',
          GROSS: 'Gross',
          SWIFT: 'SWIFT',
          INTRABANK_TRANSFER_OWN: 'Intrabank transfers to own accounts',
          INTRABANK_TRANSFER_FOREIGN: 'Intrabank transfers to other Bank clients’ accounts',
          RKO_2_BUSINESS_CARD_OWN: 'Transfer to Business Card',
          INTRABANK_TRANSFER_RKO_2_CARD_OWN: 'Transfer to Business Card',
          RKO_2_BUSINESS_CARD_FOREIGN: 'Transfer to Optima24',
          RKO_2_INDIVIDUAL_CARD_FOREIGN: 'Transfer to Optima24',
          RKO_2_INDIVIDUAL_CARD_OWN: 'Transfer to Optima24',
          BUSINESS_CARD_2_RKO_OWN: 'Transfer from Business Card to Settlement Account',
          BUSINESS_CARD_2_RKO_FOREIGN: 'Transfer from Business Card to Settlement Account',
          CONVERSION: 'Currency Conversion',
          BUDGET_PAYMENT: 'Budget Payments',
          SALARY: 'Payroll Project',
          TRANSFER_BY_INVOICE: 'Invoice payment',
          REFUND: 'QR payment refund',
          QR: 'Payment/transfer via QR',
        },
        DEFAULT: 'Other Currencies',
        CREATE_OPERATION: 'Create Operation',
        SIGN_OPERATION: 'Sign Operation',
        TIME: 'until {value}',
      },
    },
    CHANGE_PASSWORD: {
      TITLE: 'Change Password',
      SUCCESSFULLY: 'Password successfully changed',
      FAILED: 'Failed to change password',
      CURRENT_OPT_INCORRECT: 'Current password or TOTP code is incorrect!',
      LOGIN_OB: 'The password will be used to log in to Optima Business',
      CURRENT: 'Current Password',
    },
    CHANGE_PHONE: {
      NUMBER_OB: 'Change Phone Number in Optima Business',
      SUCCESSFULLY: 'Phone number successfully changed',
      TRY_ENTER_NEW: 'Try entering a new one',
      ENTER_CODE_SENT: 'Enter the code sent to the new phone number',
      NEW_OLD_SAME: 'The new phone number matches the previously registered one',
      REGISTERED: 'Registered Phone Number',
      NEW: 'New Phone Number',
      SMS_CODE: 'SMS Code',
    },
    VISIBILITY_ACCOUNT: {
      FAILED_CHANGE_ACCOUNT_VISIBILITY: 'Failed to change account visibility setting',
      FAILED_GET_INVOICES: 'Failed to retrieve accounts',
    },
    PAY_CONTROL: {
      INFO: 'Information about Pay Control',
      REGISTRATION: 'Pay Control Registration',
      SUCCESS_GENERATED: 'Pay Control successfully generated',
      ERROR: 'Error generating Pay Control',
      IDENTIFIER: 'Identifier:',
      VALIDITY: 'Validity period:',
      REISSUE_KEY: 'Reissue key',
      RELEASE_KEY: 'Issue key',
    },
    API_KEY: {
      TITLE: 'Key (API Key)',
      HELP: {
        LABEL: 'What is API Key',
        DESCRIPTION: 'This is a code of letters and numbers that allows you to exchange data in encrypted form',
      },
      DIALOG: {
        SAVE: {
          TITLE: 'Confirm that you saved API Key',
          MESSAGE: 'Click “Key was copied and saved” and then “Done”',
        },
        WARNING: {
          TITLE: 'Do you want to re-create a key?',
          MESSAGE: 'Re-creation will delete currently active key',
        },
      },
      HINT: 'This is how you will have access to it. Key is active for 90 days',
      KEY: 'Key',
      KEY_TYPE: 'Key type',
      KEY_STATE: {
        ACTIVE: 'Active',
        INACTIVE: 'Your key is deactivated',
        NEW: 'New key',
      },
      CATEGORIES: {
        QR: 'QR Generation',
        QR_DATA_REQUEST: 'Request for QR payment data',
        OUTLET: 'List of sales points and cash desks',
        POS_OPERATION_STATEMENT: 'Statement of POS and QR payments',
        QR_OPERATION_STATEMENT: 'Statement of QR payments',
      },
      KEY_COPY: 'Copy and save API Key',
      KEY_COPIED: 'Key was copied and saved',
      CHOOSE_CATEGORY: 'Select category',
      VALID_UNTIL: 'End of activity',
      CATEGORY: 'Category',
    },
    TOTP_CONTAIN_SIX_DIGITS: 'TOTP code must contain 6 digits',
    SET: 'Set',
  },
  CHECK_TYPES: {
    UPP_LOW_CASE_LATIN: 'uppercase and lowercase Latin letters',
    NUMBERS: 'numbers',
    SYMBOLS: "symbols {'.!@#$%^&*-'}",
    BETWEEN_CHARACTERS: 'from 8 to 255 characters',
  },
  EXTRA_SETTINGS: {
    TITLE: 'More',
    SUBTITLE: 'Call center, Help',
    CATEGORIES: {
      PRODUCTS: 'PRODUCTS',
      MAIN: 'MAIN',
      COMMUNICATION: 'CONTACT THE BANK',
    },
    NAV: {
      FAQ: {
        TITLE: 'Help',
        DESCRIPTION: 'Frequently asked questions and answers',
        USER_GUIDE: 'User Guide',
      },
      CALL_CENTER: {
        TITLE: 'Call center',
        DESCRIPTION: '7711 toll-free',
      },
    },
  },
  MORE: {
    TITLE: 'More',
    SUB_TITLE: 'Contact the bank',
  },
  ACCOUNT: {
    TITLE: 'My Accounts',
    STATUS_TITTLE: {
      OPEN: 'Open',
      CLOSED: 'Closed',
      ARRESTED: 'Frozen',
      FINAL_ARRESTED: 'Blocked',
    },
    CURRENT: 'Current Account',
    EMPTY: 'No available accounts',
    EMPTY_BY_ACCESS: 'You do not have permission to make payments. Please contact {company_name} .',
    MULTI_CURRENCY_REQUIRED:
      'A multi-currency account is required to perform this operation. You can open one at a bank branch.',
    SEVERAL_ACCOUNTS_REQUIRED:
      'To transfer between accounts, you must have several settlement accounts open. You can open an additional account at a bank branch.',
    ERROR: 'Failed to retrieve accounts',
    AVAILABLE_BALANCE_DETAILS: {
      TITLE: 'Detailed account information',
      ACTUAL: 'Actual balance',
      PENDING_TOTAL: 'Total amount of payments being signed and in processing:',
      PAYMENT_COUNT: 'no payments | {n} payment | {n} payments | {n} payments',
      SIGNING_LABEL: 'Being signed:',
      SIGNING_LABEL_MOBILE: 'Signing in Optima Business:',
      PROCESSING_LABEL: 'In processing:',
      AVAILABLE: 'Available balance',
    },
  },
  DOCUMENTS: {
    TITLE: 'Documents',
    REQUISITES: {
      NAV: 'Details',
      FILES: {
        FILE_ONE: {
          TITLE: 'Requisites for incoming interbank transfer crediting',
          DOWNLOAD: 'Download',
          SHARE: 'Share',
        },
      },
      DOWNLOADING: 'File is downloading',
      ERROR: 'Failed to download requisites',
    },
    STATEMENT_ACCOUNT: {
      TITLE: 'Statements',
      NAV: 'Statements',
      DOWNLOAD_PDF: 'Download PDF file',
      DOWNLOAD_XLSX: 'Download Excel file',
      DOWNLOADING: 'File is downloading',
      ORDER_FORMED: 'Order is being processed',
      ORDER: {
        EXTRACT: 'Generate Statement',
        OPTIONS: 'Statement options',
        VIEW: 'View',
        WITHOUT_QR_DETAILS: 'Without QR transactions details',
        WITH_QR_DETAILS: 'With QR transactions details',
        MULTIPLE_CURRENCY: 'Multiple currencies can be selected',
        DATE_FROM: 'Date from',
        DATE_TO: 'Date to',
        PERIOD_FILTER: {
          TITLE: 'Period filter',
          BY_REIMBURSEMENT: 'By reimbursement date',
          BY_TRANSACTION_DATE: 'By transaction date',
          REIMBURSEMENT_DESCRIPTION:
            'By reimbursement — the date funds were credited to the settlement account or card',
          TRANSACTION_DESCRIPTION: 'By transaction date — the date the payment was made',
        },
      },
      STATUS: {
        IN_PROGRESS: 'In progress',
        READY: 'Statement generated',
        NOT_FOUND: 'No data for the selected period',
        FAIL: 'Failed to generate statement',
        PENDING: 'Pending',
      },
      COLUMN_TABLE: {
        ACCOUNT: 'Account Number',
        PERIOD: 'Statement Period',
        REQUEST_DATE: 'Request Date',
      },
      ALL_ACCOUNT: 'For all accounts',
      EMPTY: 'You have no statements yet.\nClick “Create statement” to create.',
      HAS_NOT_POS: 'You have no statements yet.\n' + 'Click “Create statement” to create',
      ERROR: 'Failed to retrieve statements',
      ORDER_EXTRACT: {
        IN_PROCESSING: 'Statement request accepted for processing',
        FAIL: 'Unable to create statement',
      },
      OUTLET: {
        SELECT_ALL_OUTLET: 'All sale points',
        SELECT_ALL_POS: 'All POS terminals',
        SELECT_ALL_POS_AND_KIOSKS: 'All POS + kiosks',
        POS_NUMBER: 'Number POS terminals',
      },
      RANGE_DATE: {
        TODAY: 'Today',
        YESTERDAY: 'Yesterday',
        WEEK: 'Week',
        MONTH: 'Month',
      },
    },
    DEVICE_STATEMENTS: {
      NAV: 'Device Statements',
      DEVICE_NAME: 'Store name',
      POS_NUMBER: 'Device Number (POS)',
    },
  },
  EMPLOYEES: {
    TITLE: 'Employees',
    SALARY: {
      SAVED_SUCCESSFULLY: 'Role settings updated',
    },
    DETAILS: {
      ACCOUNT_SETTINGS: 'Account Settings',
      EMPLOYEE: 'Employee:',
      ROLE: 'Role:',
      ACCOUNT_NUMBER: 'Account Number',
      TREATY: 'Agreement',
      ACCOUNTS: {
        TITLE: 'Accounts',
        SAVED_SUCCESSFULLY: 'Account settings updated',
        ACCOUNTS_EMPTY: 'None',
      },
      POINT_ACCESS: {
        TITLE: 'Access to points',
        SUBTITLE: 'Manage access to points',
        ENABLE_ALL: 'Enable all points',
        SEARCH_PLACEHOLDER: 'Sale point name',
      },
    },
    LIST: {
      FULL_NAME: 'Full Name',
      PHONE_NUMBER: 'Phone Number',
      ROLE: 'Role',
      DATE_OF_REGISTRATION: 'Registration Date',
      MISSING_EMPLOYEES: 'No employees available',
    },
    STATUS: {
      ACTIVE: 'Active',
      FREEZE: 'Blocked',
    },
    ROLE: {
      CREATOR: 'Executor',
      FIRST: 'First Signature Right',
      SECOND: 'Second Signature Right',
      AUDITOR: 'Auditor',
      NONE: 'No Signature',
      CASH_MANAGER: 'Manager',
      CASHIER: 'Cashier',
    },
    SETTINGS: {
      ERROR: 'Failed to retrieve employee list',
    },
  },
  IMPORTED: {
    TITLE: 'Imported',
    FILE_NAME: 'File name',
    DATE_DOWNLOAD: 'Download date',
    CREATE_OPERATION: 'Create operations',
    RETRY_UPLOAD: 'Retry file upload',
    FAILED_IMPORTED: 'Imported files receipt failed',
    GO_OPERATION: 'Go to operation',
    CAUSE: 'Cause',
    PAYMENT_PROCESSING: 'Payment processing',
    STATUS_FILE: {
      PROCESSED: 'Processed',
      REJECTED: 'Rejected',
      ERROR_PROCESSING: 'Processing error',
      PREPARING: 'Preparing...',

      PAYMENT: {
        PROCESSING: 'In processing',
        UNPROCESSABLE: 'Check file content',
        FAILED: 'Error in operation creation',
        DENIED: 'Operation creation was denied',
        UPLOADING: 'Operations creation...',
        UPLOADED: 'Created operations',
        EDITED: 'This operation has been edited',
        ERROR_UPLOADING: 'Error in operation creation',
        PARTIALLY_PROCESSED: 'Partially processed',

        FILE_VALIDATION_PROCESSING: 'Statement verifying...',
        FILE_VALIDATION_FINISHED: 'Statement is in order',
        FILE_VALIDATION_ERROR: 'Verify data',
        BUSINESS_VALIDATION_PROCESSING: 'Details verifying...',
        BUSINESS_VALIDATION_FINISHED: 'Details are in order',
        BUSINESS_VALIDATION_ERROR: 'Check accounts to be debited and credited',
        SALARY_CREATION_PROCESSING: 'Create statement...',
        SALARY_CREATION_FINISHED: 'Statement and payment have been created',
        SALARY_CREATION_ERROR: 'Something went wrong. Try again',
        ERROR_CONFIRMED: 'In the archive',
        PROCESSING_COMPLETED: 'Ready for signing',
      },
      SALARY: {
        PROCESSING: 'In processing',
        UNPROCESSABLE: 'Unprocessable payments',
        FAILED_PREPARING: 'Failed attempt during preparing',
        ERROR_PREPARING: 'Error during preparing',
        READY_FOR_EXECUTION: 'Ready for execution',
      },
    },
    STATUS_PAYMENT: {
      OK: 'Processed',
      REJECTED: 'Rejected',
    },
    EMPTY: 'Missing files',
    CHOOSE_FILE_TYPE: {
      TITLE: 'Select the type',
      LABEL: 'Please select the type for interbank transfers with an amount lower than or equal to 1 million soms',
    },
    WARNING: '*transfers with an amount over 1 million soms are automatically sent by the Gross type',
  },

  PAYMENT: {
    TITLE: 'Payment',
    FOR_SIGN: 'Payments for sign',
    NO_ACCESS_OPERATION: {
      TITLE: 'Didn’t find the account you need?',
      DESCRIPTION: 'You don’t have access to it. Please ask the Primary Signatory to grant you permissions.',
      MANAGER_HINT: 'How a manager can grant access:',
      STEPS:
        'Settings → Employees → Select the required employee → Select the required account → Enable the toggle for the required operation.',
    },
    TYPE: {
      CLEARING: 'Clearing',
      GROSS: 'Gross',
      CLEARING_GROSS: 'Clearing/Gross',
      SWIFT: 'SWIFT',
      INTRABANK_TRANSFER_OWN: 'Transfer between own accounts',
      INTRABANK_TRANSFER_FOREIGN: 'Transfer to other client accounts',
      INTRABANK_TRANSFER_RKO_2_CARD_OWN: 'Transfer to Business Card',
      RKO_2_BUSINESS_CARD_OWN: 'Transfer to Business Card',
      RKO_2_BUSINESS_CARD_FOREIGN: 'Transfer to Optima24',
      RKO_2_INDIVIDUAL_CARD_FOREIGN: 'Transfer to Optima24',
      RKO_2_INDIVIDUAL_CARD_OWN: 'Transfer to Optima24',
      BUSINESS_CARD_2_RKO_OWN: 'Transfer from Business Card to current account',
      BUSINESS_CARD_2_RKO_FOREIGN: 'Transfer from Business Card to current account',
      INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_OWN: 'Transfer from Business Card to own accounts',
      INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_FOREIGN: 'Transfer from Business Card to other current accounts',
      CONVERSION: 'Conversion',
      BUDGET_PAYMENT: 'Budget Payment',
      REFUND: 'QR payment refund',
      TRANSFER_BY_INVOICE: 'Invoice payment',
      NO_TITLE: 'No Title',
      BETWEEN_ACCOUNTS: 'Between own accounts',
      INTRABANK_TRANSFER: 'Intrabank Transfer',
      VIEW_ACCOUNT: 'View Account',
      VIEW_LOAN_CLAIM: 'View Loan Information',
      SALARY: 'Salary Project',
      QR: 'Payment/transfer via QR',
    },
    ORIGIN: {
      ALL: 'All',
      MANUAL: 'Manual',
      DIRECT_BANK: '1C',
      FILE: 'Imported',
    },
    NOTIFICATIONS: {
      MESSAGE: {
        ERROR: {
          TITLE: 'Payment <span class="text-primary">Rejected by Bank</span>',
          TITLE_TEXT: 'Payment Rejected by Bank',
          TEXT: '"{operationCode}" No.{transferNum} amount {amount} {currency}',
        },
        PAYMENT_REQUEST_TO_BANK: {
          TITLE: 'Payment <span class="text-primary">Rejected by Bank</span>',
          TITLE_TEXT: 'Payment Rejected by Bank',
          TEXT: '"{operationCode}" No.{transferNum} amount {amount} {currency} \n( {text} )',
        },
      },
    },
    TEMPLATES: {
      TITLE: 'Templates',
      NAME: 'Template Name',
      SEARCH: 'Search Templates',
      CREATED: 'Template saved',
      EDIT: 'Edit Template',
      EDITING: 'Editing Template',
      EDITED: {
        SUCCESS: 'Template updated',
        ERROR: 'Failed to update template',
      },
      DELETE: 'Delete Template',
      DELETED: 'Template deleted',
      NOT_FOUND: 'No templates found',
      CREATE: 'Create Template',
    },
    DIALOG: {
      EXIT: {
        TITLE: 'Do you really want to get out of the payment process?',
        LABEL: 'If you leave now, all the data you entered may be lost.',
      },
    },
  },
  STATEMENT: {
    TRANSACTION: {
      DATE: {
        TODAY: 'Today',
        TODAY_TIME: 'Today at {time}',
        YESTERDAY: 'Yesterday',
        YESTERDAY_TIME: 'Yesterday at {time}',
      },
      EMPTY: {
        SUCCESS: 'No completed transactions',
        ON_SIGN: 'No transactions to sign',
        REJECTED: 'No rejected transactions',
        ERROR: 'No bank-rejected transactions',
        FOR_EDITING: 'No transactions for editing',
        DRAFT: 'Your draft list is empty',
      },
      EMPTY_STATEMENT: 'No transactions',
      DELETE: 'Delete',
      DOWNLOAD: 'Download PDF',
      DOWNLOAD_STATEMENT: 'Download a statement',
      SCHEME: 'Show scheme',
      GET: 'Download',
      OPEN: 'Open',
      EDIT: 'To edit',
      EDIT_ALL: 'Edit all',
      CHANGE: 'Edit',
      REPEAT: 'Repeat',
      REVOKE: 'Reject',
      REVOKE_ALL: 'Reject all',
      SIGN: 'Sign payment',
      SIGN_ALL: 'Sign all',
      SEND_FOR_SIGN: 'Send for signing',
      SEND_AFTER_CHANGE: 'Send for signing',
      RECALL: 'Recall',
      PRINT: 'Print',
    },
    TRANSFER_ACTIONS: {
      DELETE: 'Delete',
      EDIT: 'Edit payment',
      EDITING: 'Editing payment',
      CHANGE: 'Edit',
      REPEAT: 'Repeat',
      REVOKE: 'Reject',
      SIGN: 'Sign',
      TITLE: 'Payment details',
      FOR_SIGN: 'For signing',
      RECALL: 'Recall payment',
    },
    NOTIFICATIONS: {
      TITLE: 'Statement',
      TITLE_MANY: 'Statements',
      OK: 'OK',
      GO_ON: 'Proceed',
      MESSAGE: {
        READY: 'Statement generated',
        FAIL: 'Failed to generate',
        NOT_FOUND: 'No statement data for the selected period',
        MANY_STATEMENT: 'Requests generated',
      },
    },
    DIALOG: {
      FAIL: 'Failed to generate statement',
    },

    EMPTY: 'No uploaded statements',
    ERROR: {
      TITLE: 'An error occurred while loading the statement',
    },
  },
  EXCHANGE_RATES: {
    ALL_RATES: 'All rates',
    PURCHASE: 'Purchase',
    SALE: 'Sale',
    FOR: 'for',
    RATES_LOADING_ERROR: 'Failed to load exchange rates. Try refreshing the section',
    CASH: 'Cash rates',
    CASHLESS: 'Cashless rates',
    CARD: 'Card rates',
    NBKR: 'NBKR rates',
    RATES: 'Exchange rates',
    ALL_EXCHANGE_RATES: 'All currency rates',
  },
  SIGNATORIES: {
    MANY_SIGNATORY: 'Signatories',
    PRIMARY_SIGNATURE: 'Primary Signature',
    SECONDARY_SIGNATURE: 'Secondary Signature',
    PROCESSING_SIGNATURE: 'Awaiting Signature',
    ON_VERIFICATION_COMPLETED: 'Signed',
    PARTIAL_CONFIRMATION_COMPLETED: 'Signed',
    CANCELED_SIGN_ONE: 'Rejected',
    CANCELED_SIGN_TWO: 'Rejected',
    FOR_EDITING: 'Rejected',
    REVOKE: 'Revoked',
    ON_CONFIRMATION_COMPLETED: 'Sent to Bank',
  },
  FILTER_HISTORY: {
    FILTER: 'Filter',
    SEARCH: 'Search',
    PAYMENT_TYPE: 'Payment Type',
    PAYMENT_ORIGIN: 'Origin',
    PURPOSE: 'Appointment',
    DATE_FROM: 'Date from',
    DATE_TO: 'Date to',
    AMOUNT_FROM: 'Amount from',
    AMOUNT_TO: 'Amount to',
    APPLY: 'Apply',
    RESET: 'Reset',
    WITH: 'from {value}',
    BEFORE: 'to {value}',
    RULE_AMOUNT: 'Start amount cannot exceed end amount!',
    RULE_THREE_MONTH_PERIOD: 'Specify no more than 3 months',
    ASCENDING: 'Ascending',
    DESCENDING: 'Descending',
    BY_DEADLINE: 'By due date',
    BY_TOTAL: 'By amount',
    BY_QR_TYPE: 'By QR type',
    BY_QR_TRANSACTION_TYPE: 'By transaction type',
  },
  NOTIFICATION: {
    READ_ALL: 'All read',
    TITLE: 'Notifications',
    EMPTY: 'You don’t have any notifications yet',
    STATUS: {
      ERROR: {
        TEXT: 'The bank rejected the payroll statement. Amount: {amount} {currency}.',
      },
      SUCCESS: {
        TEXT: 'The bank approved the payroll statement. Amount: {amount} {currency}.',
      },
    },
  },
  RECAPTCHA: {
    TEXT: 'This site is protected by reCAPTCHA and Google',
    AND: 'and',
    PRIVACY_POLICY: 'Privacy Policy',
    TERMS_OF_SERVICE: 'Terms of Service',
  },
  ERRORS: {
    AUTH: {
      OTP_INCORRECT: 'Incorrect TOTP code',
      PERMANENT_LOCKOUT_EXCEPTION: 'User is blocked!',
      USER_CREDENTIALS_EXCEPTION: 'Invalid client ID or password',
      PHONE_ALREADY_EXISTS: 'Invalid phone number',
      USER_STATE_INCORRECT: 'You have not completed initial registration. Password reset is not possible.',
      UNKNOWN: 'Error. Please try again later.',
    },
    PAYMENT: {
      SWIFT_RSBANK_EXCEPTION:
        'Transfer to the selected bank is not possible due to the internal policy of the correspondent bank.',
      ACCOUNT_DEBIT_NOT_FOUND: 'No debit account found.',
      ACCOUNT_CREDIT_NOT_FOUND: 'No beneficiary account found.',
      OPERATION_NOT_ALLOWED: 'This type of operation is prohibited!',
      ACCOUNT_NOT_ACCESSIBLE: 'This account is not available to you!',
      ACCOUNT_DEBIT_CLOSED_OR_SEIZED: 'Debit account is closed or seized.',
      ACCOUNT_CREDIT_CLOSED_OR_SEIZED: 'Beneficiary account is closed or seized.',
      INVALID_OPERATION_TYPE: 'This type of operation is impossible on this account.',
      INSUFFICIENT_FUNDS: 'Funds are insufficient in the account.',
      CURRENCY_MISMATCH_FOR_CONVERSION: 'Accounts with different currencies should be selected for Conversion.',
      INVALID_PAYMENT_TYPE_FOR_INTERNAL_ACCOUNT: 'This type of payment is not suitable for intra-bank account.',
      CURRENCY_MISMATCH_BETWEEN_ACCOUNTS: 'Debit account currency does not match beneficiary account currency.',
      INVALID_OPERATION_FOR_YOUR_COMPANY: 'Select another operation to transfer to your legal entity’s account.',
      INVALID_OPERATION_FOR_OTHER_COMPANY: 'Select another operation to transfer to another legal entity’s account.',
      ACCOUNT_NOT_ASSOCIATED_WITH_LEGAL_ENTITY: 'Debit account currency does not match beneficiary account currency.',
      BLOCKED_OR_NON_ASSOCIATED_EMPLOYEE: 'Transfer to cards account is not available.',
      OPERATION_NOT_AVAILABLE_IN_CURRENCY: 'Account is not legal entity’s account.',
      INVALID_REQUISITE_EXCEPTION: 'Transfers to Elcart by card account number are not available',
      INVALID_CARD_TYPE_CODE_EXCEPTION: 'Transfers to Elcart Business are not available',
      CHECK_RU_CITIZEN_EXCEPTION:
        'According to the correspondent bank’s restrictions, euro transfers are not available',
      INVOICE_NOT_FOUND: 'Invoice not found',
      WRONG_INVOICE_TYPE: 'The invoice has an invalid type',
      WRONG_INVOICE_STATE: 'Invoice cannot be modified in the current status',
      INVOICE_IS_PAID: 'Invoice already paid. Cancellation is not allowed',
      CLIENT_NOT_FOUND: 'Client not found',
      RECIPIENT_NOT_FOUND: 'Recipient or account number not found',
      PAYER_EXCEPTION: 'Payer and recipient cannot be the same',
      PAYER_NOT_EMPTY_EXCEPTION: 'Payer is not specified for external invoices',
      ELQR_NOT_CREATED: 'Failed to generate QR',
      WRONG_DETAIL_AMOUNT: 'Item total does not match price and quantity',
      WRONG_AMOUNT: 'Invoice total amount does not match items total',
      ALREADY_EXISTS_EXCEPTION: 'A product/service with this name already exists',
      OPERATION_NOT_VALID_EXCEPTION: 'A payment already exists for this invoice',
      INVALID_INVOICE_STATE: 'Cannot create a payment for this invoice in the current status',

      CHECK_FIELD_FOR_NULL_EXCEPTION: 'Missing some data in payment, check the file.',
      FILE_NOT_FOUND_EXCEPTION: 'This file is missing.',
      FILE_PREPARE_TO_CREATE_EXCEPTION: 'Error during preparation for creation.',
      FILE_REPEAT_EXCEPTION:
        "Error while repeating processing: files with the status 'Processing Error' can be repeated.",
      FILE_STATE_MISMATCH_EXCEPTION:
        "Error while creating payments: payments can only be created from file with the statuses: 'Processed', 'Failed', 'Error while uploading'.",
      FILE_SIZE_EXCEPTION: 'File size exceeds allowed value.',
      FILE_EXTENSION_EXCEPTION: 'File extension does not match expected value.',
      DUPLICATE_PAYMENT_IN_IMPORTED_FILE_EXCEPTION: 'Payments in file are duplicated: check/change data.',
      CANT_DETERMINE_ORGANIZATION_EXCEPTION: 'Error, please contact bank branch.',
      DOCUMENT_NUMBER_ALREADY_EXISTS_EXCEPTION:
        'Current payment order number was already used, please use unique number.',
      FORBIDDEN_EXCEPTION: 'Error, access denied.',
      NOT_ALLOWED_DELETE_OPERATION: 'It is impossible to delete, you should generate letter to bank.',
      PROCESS_ALREADY_EXISTS_EXCEPTION: 'Error. This operation is being processed.',
      RULE_EXCEPTION: 'Error. Please check correctness of entered data',
      ACTIVITI_PROCESS_ALREADY_EXISTS_EXCEPTION: 'Error, payment already exists.',
      INTRA_AND_INTER_BANK_BIC_CORRESPONDENCE_EXCEPTION:
        'BIC and accounts mismatch. (in case this is a transfer to a transit account, make sure that yours and the transit account are from the same branch)',
      INTERBANK_INVALID_CURRENCY_EXCEPTION: 'Invalid currency for Clearing/Gross.',
      INTERBANK_SAME_BIC_CODES_EXCEPTION: 'Invalid BIC for Clearing/Gross payment.',
      INTRA_AND_INTERBANK_BBAN_ACCOUNT_STRUCTURE_EXCEPTION: 'Error, beneficiary account structure does not match BBAN.',
      INTRA_AND_INTERBANK_SAME_ACCOUNT_EXCEPTION: 'Error, sender and beneficiary accounts must be different.',
      INTRABANK_DIFFERENT_BIC_CODES_EXCEPTION: 'Invalid BIC for intra-bank payment.',
      INVALID_VALUE_DATE_EXCEPTION: 'Error, past dates cannot be selected.',
      NOT_WORKING_DAY_FOR_VALUE_DATE_EXCEPTION: 'Error, selected value date is not business day.',
      SWIFT_INVALID_EXOTIC_CURRENCY_EXCEPTION: 'Invalid currency for SWIFT in exotic currency.',
      FILE_READING_EXCEPTION: 'Error while reading the file. The file contents does not match the expected.',

      INVALID_PAYER_BANK_EXCEPTION: "BIC of payer's bank was not found.",
      INVALID_RECIPIENT_BANK_EXCEPTION: "BIC of recipient's bank was not found.",
      INVALID_PAYMENT_CODE_EXCEPTION: 'Payment code was not found.',
      LEGAL_PARTY_ID_CANT_BE_NULL_EXCEPTION: "There is no Company's ID.",
      PAYER_ACCOUNT_CANT_BE_NULL_EXCEPTION: 'There is no account to be debited.',
      PAYER_BIC_CANT_BE_NULL_EXCEPTION: "There is no payer's BIC.",
      PAYER_NAME_CANT_BE_NULL_EXCEPTION: "There is no payer's name.",
      PAYER_AMOUNT_CANT_BE_NULL_EXCEPTION: 'There is no debited amount.',
      PAYER_CURRENCY_CANT_BE_NULL_EXCEPTION: 'There are no data on debited currency.',
      RECIPIENT_ACCOUNT_CANT_BE_NULL_EXCEPTION: 'There is no account to be credited.',
      RECIPIENT_BIC_CANT_BE_NULL_EXCEPTION: "There is no recipient's BIC.",
      RECIPIENT_NAME_CANT_BE_NULL_EXCEPTION: "There is no recipient's name",
      RECIPIENT_AMOUNT_CANT_BE_NULL_EXCEPTION: 'There is no credited amount',
      RECIPIENT_CURRENCY_CANT_BE_NULL_EXCEPTION: 'There is no credited currency.',
      AMOUNT_CANT_BE_NULL_EXCEPTION: 'There is no payment amount.',
      CURRENCY_CANT_BE_NULL_EXCEPTION: 'There is no payment currency.',
      PURPOSE_CANT_BE_NULL_EXCEPTION: 'There is no payment purpose.',
      COMMISSION_ACCOUNT_CANT_BE_NULL_EXCEPTION: 'There is no account for fee payment.',
      COMMISSION_CURRENCY_CANT_BE_NULL_EXCEPTION: 'There is no fee account currency.',
      COMMISSION_OPTION_CANT_BE_NULL_EXCEPTION: 'There are no data on tariffication.',
      IS_EXOTIC_CANT_BE_NULL_EXCEPTION: 'There are no data on exotics amount.',
      EXOTIC_AMOUNT_CANT_BE_NULL_EXCEPTION: 'There are no data on exotics amount.',
      EXOTIC_RATE_CANT_BE_NULL_EXCEPTION: 'There are no data on exotics rate.',
      EXOTIC_CURRENCY_CANT_BE_NULL_EXCEPTION: 'There is no exotic currency.',
      RUB_CODE_VO_CANT_BE_NULL_EXCEPTION: 'There is no VO Code.',
      RUB_INN_CANT_BE_NULL_EXCEPTION: 'There is no TIN (RUB).',
      KZT_BIN_CANT_BE_NULL_EXCEPTION: 'There is no BIN.',
      KPP_CANT_BE_NULL_EXCEPTION: 'There is no KPP.',
      VALUE_DATE_CANT_BE_NULL_EXCEPTION: 'There is no value date.',
      OPERATION_CANT_BE_NULL_EXCEPTION: 'There is no operation.',
      PAYER_INN_CANT_BE_NULL_EXCEPTION: "There is no payer's TIN.",
      PAYMENT_CODE_CANT_BE_NULL_EXCEPTION: 'There is no payment code.',
      RUB_CODE_VO_MUST_BE_NULL_EXCEPTION: 'VO Code should not be specified.',
      RUB_INN_MUST_BE_NULL_EXCEPTION: 'TIN (RUB) should not be specified.',
      KZT_BIN_MUST_BE_NULL_EXCEPTION: 'BIN should not be specified.',
      KPP_MUST_BE_NULL_EXCEPTION: 'KPP should not be specified.',
      EXOTIC_AMOUNT_MUST_BE_NULL_EXCEPTION: 'Exotics amount should not be specified.',
      EXOTIC_RATE_MUST_BE_NULL_EXCEPTION: 'Exotics rate should not be specified.',
      EXOTIC_CURRENCY_MUST_BE_NULL_EXCEPTION: 'Exotic currency should not be specified.',
      INSUFFICIENT_FUNDS_EXCEPTION: 'Payment amount exceeds available account balance',

      CELL_VALUE_DATE_IS_EMPTY: 'Enter the date in the appropriate cell.',
      CELL_VALUE_DATE_DATA_IS_INVALID_WORKING_DAY: 'The value date cannot be a day off.',
      CELL_VALUE_DATE_DATA_IS_INVALID_TIME: 'The allowed time has already expired, try another day.',
      CELL_VALUE_DATE_DATA_IS_INVALID_DATE: 'Value date can only be current.',
      CELL_LEGAL_PARTY_ID_IS_EMPTY: 'Fill in the field "Company ID".',
      CELL_COMPANY_NAME_IS_EMPTY: 'Fill in the field "Company Name".',
      CELL_ACCOUNT_IS_EMPTY: 'Fill in the field "Transit account" in the appropriate cell.',
      CELL_AMOUNT_IS_EMPTY: 'Empty field "Total Amount".',
      CELL_COMMISSION_IS_EMPTY: 'Fill in the field "Bank Commission".',
      CELL_TOTAL_AMOUNT_IS_EMPTY: 'Empty field "Total Amount".',
      CELL_CURRENCY_IS_EMPTY: 'Fill in the field "Currency".',
      CELL_FORMULA_TOTAL_AMOUNT_IS_EMPTY: 'Empty field "Calculated Amount".',
      DETAILS_CELL_CARD_ACCOUNT_IS_EMPTY: 'Fill in the field "Employee\'s Account".',
      DETAILS_CELL_AMOUNT_IS_EMPTY:
        'Fill in the field for the amount to be credited to an employee in the appropriate cell.',
      DETAILS_CELL_EMPLOYEE_NAME_IS_EMPTY: 'Fill in the field "Employee\'s Full Name".',
      CELL_VALUE_DATE_INVALID_FORMAT: 'Mandatory format of the cell with information on date - "Short Date Format".',
      CELL_LEGAL_PARTY_ID_INVALID_FORMAT:
        'Mandatory format of the cell with information on Company ID - "General/Text".',
      CELL_COMPANY_NAME_INVALID_FORMAT:
        'Mandatory format of the cell with information on company name - "General/Text".',
      CELL_ACCOUNT_INVALID_FORMAT: 'Mandatory format of the cell with information on account   - "General/Text".',
      CELL_AMOUNT_INVALID_FORMAT:
        'Mandatory format of the cell with information on aggregate amount - "General/Numeric".',
      CELL_COMMISSION_INVALID_FORMAT:
        'Mandatory format of the cell with information on bank commission - "General/Numeric". The maximum number of numbers in the fractional part of the amounts in the statement file is 2 pcs.',
      CELL_TOTAL_AMOUNT_INVALID_FORMAT:
        'Mandatory format of the cell with information on total amount - "Total/Numeric".',
      CELL_CURRENCY_INVALID_FORMAT: 'Mandatory format of the cell with information on currency - "General/Text".',
      CELL_FORMULA_TOTAL_AMOUNT_INVALID_FORMAT:
        'Mandatory format of the cell with information on calculated amount  - "General/Numeric".',
      DETAILS_CELL_CARD_ACCOUNT_INVALID_FORMAT:
        'Mandatory format of the cell with information on the employee\'s account - "General/Text".',
      DETAILS_CELL_AMOUNT_INVALID_FORMAT:
        'Mandatory format of the cell with information on the amount to be credited to the employee\'s account - "General/Numeric". The maximum number of numbers in the fractional part of the amounts in the statement file is 2 pcs.',
      DETAILS_CELL_EMPLOYEE_NAME_INVALID_FORMAT:
        'Mandatory format of the cell with information on the employee\'s full name - "General/Text".',
      CELL_VALUE_DATE_DATA_IS_INVALID: 'Value date can only be current.',
      CELL_ACCOUNT_DATA_IS_INVALID: 'Mandatory format of debited current account: 16 digits, 109#############',
      CELL_CURRENCY_DATA_IS_INVALID: 'Permissible currency: KGS/USD',
      DETAILS_CELL_CARD_ACCOUNT_DATA_IS_INVALID:
        "Mandatory format of the employee's card account: 16 digits, 109#############",
      DETAILS_CELL_AMOUNT_DATA_IS_INVALID: "The amount to be credited to employee's account cannot be negative.",
      DETAILS_LIST_IS_EMPTY: "Employees' list is missing.",
      INVALID_SALARY_TOTAL_AMOUNT_SUM:
        'The "Amount to be credited to card accounts" and the calculated amount  from the employees\' list to be credited do not match.',
      INVALID_SALARY_AMOUNT_COMPARISON: '"Amount to Be Credited to Card Accounts" and "Calculated Amount" do not match',
      INVALID_SALARY_TOTAL_AMOUNT_CALCULATION:
        'Incorrectly calculated total amount including commission (use the formula from the template).',
      SALARY_DETAIL_DUPLICATE_EXCEPTION: "Employee's duplicate account was detected .",
      //FORBIDDEN_EXCEPTION: 'Statement does not belong to the current organisation.',
      SALARY_DUPLICATE_EXCEPTION: 'Current file name has already been used.',
      ERROR: 'An error occurred during payroll statement processing. Please try again.',
      SUCCESS: 'File was successfully loaded.',
      ACCOUNT_ERROR: 'Account was not found.',
      CURRENCY_ERROR: 'Account with selected currency was not found. Check and try again.',
      SUM_ERROR: 'Reason: total amount is incorrect.',
      CONTRACT_NOT_FOUND_ERROR: 'Contact was not found.',
      OPERATION_DATE_ERROR: 'Reason: date related transaction day ended.',
      BALANCE_IS_LESS_AMOUNT_ERROR: 'Insufficient funds in the account.',
      ACCOUNT_DIFF_ERROR: "Organisation's account differs from the account in the statement.",
      EMPLOYEE_ACCOUNT_ERROR: 'Employee account does not exist.',
      EMPLOYEE_CURRENCY_ERROR: "Currency in the employee's account does not match the entry in the statement.",
      FULL_NAME_ERROR: "Employee's full name in the statement differs from the full name in the system.",
      EMPLOYEE_NOT_FOUND: 'An employee was not found in the contract.',

      EMPLOYEE_STATE_ERROR: "The employee's status is incorrect. Contact the branch.",
      EMPLOYEE_CARD_STATE_BLOCKED: "The employee's card account has been blocked. Contact the branch.",
      EMPLOYEE_CARD_STATE_CLOSED: "The employee's card account is closed. Contact the branch.",
      EMPLOYEE_CARD_STATE_ERROR: "Problems with the employee's card account. Contact the branch.",

      CELL_LEGAL_PARTY_ID_DATA_IS_INVALID:
        'Error: Invalid company code. Please make sure that the company ID you entered is correct and try again.',
      CLEARING_CREATION_DEADLINE_EXCEPTION:
        'The Clearing Creation Session has expired. Please choose another value date.',
      CLEARING_SIGNING_DEADLINE_EXCEPTION:
        'The Clearing Signing Session has expired. Please select another value date.',
      GROSS_CREATION_DEADLINE_EXCEPTION:
        'The Gross Transfers Creation Session has expired. Please select another value date.',
      GROSS_SIGNING_DEADLINE_EXCEPTION:
        'The Gross Transfers Signing Session has expired. Please select another value date.',
      INTRA_OWN_CREATION_DEADLINE_EXCEPTION:
        'The session for creating intra-bank transfers to own accounts has expired. Please select another value date.',
      INTRA_OWN_SIGNING_DEADLINE_EXCEPTION:
        'The session for signing intra-bank transfers to own accounts has expired. Please select another value date.',
      INTRA_FOREIGN_CREATION_DEADLINE_EXCEPTION:
        "The session for creating intra-bank transfers to other people's accounts has expired. Please select another value date.",
      INTRA_FOREIGN_SIGNING_DEADLINE_EXCEPTION:
        "The session of signing intra-bank transfers to other people's accounts has expired. Please select another value date.",
      CONVERSION_CREATION_DEADLINE_EXCEPTION:
        'The currency conversion creation session has expired. Please select another value date.',
      CONVERSION_SIGNING_DEADLINE_EXCEPTION:
        'The currency conversion signing session has expired. Please select another value date.',
      SWIFT_CREATION_DEADLINE_EXCEPTION:
        'The SWIFT transfers creation session has expired. Please select another value date.',
      SWIFT_SIGNING_DEADLINE_EXCEPTION:
        'The SWIFT transfers signing session has expired. Please select another value date.',
      SALARY_CREATION_DEADLINE_EXCEPTION:
        'The payroll payment creation session has expired. Please select another value date.',
      SALARY_SIGNING_DEADLINE_EXCEPTION:
        'The payroll payment signing session has expired. Please select another value date.',
      CREATION_DEADLINE_EXCEPTION: 'The Operation Creation Session has expired. Please choose another value date.',
      SIGNING_DEADLINE_EXCEPTION: 'The Operation Signing Session has expired. Please select another value date.',

      ACCOUNT_CREDIT_NOT_FOUND_EXCEPTION: "The recipient's account in the specified currency was not found",
      OPERATION_NOT_ALLOWED_EXCEPTION: 'The operation of the selected type is prohibited for the specified account',
      ACCOUNT_NOT_ACCESSIBLE_EXCEPTION: 'Access to the account is prohibited',
      ACCOUNT_DEBIT_CLOSED_OR_SEIZED_EXCEPTION: 'The debit account is not available',
      ACCOUNT_CREDIT_CLOSED_OR_SEIZED_EXCEPTION: 'The deposit account is unavailable',
      INVALID_OPERATION_TYPE_EXCEPTION: 'It is impossible to make the current operation on the selected account!',
      CURRENCY_MISMATCH_FOR_CONVERSION_EXCEPTION: 'To convert, the accounts must be in different currencies!',
      INVALID_PAYMENT_TYPE_FOR_INTERNAL_ACCOUNT_EXCEPTION: 'It is not possible to make a payment to intrabank accounts',
      CURRENCY_MISMATCH_BETWEEN_ACCOUNTS_EXCEPTION:
        "The currency of the debit account does not match the currency of the recipient's account",
      INVALID_OPERATION_FOR_YOUR_COMPANY_EXCEPTION: 'The accounts belong to one legal entity',
      ACCOUNT_NOT_ASSOCIATED_WITH_LEGAL_ENTITY_EXCEPTION:
        "The recipient's account does not relate to this legal entity",
      INVALID_OPERATION_FOR_OTHER_COMPANY_EXCEPTION: 'The account does not belong to a legal entity',
      BLOCKED_OR_NON_ASSOCIATED_EMPLOYEE_EXCEPTION: 'Is not an employee or is blocked',
      OPERATION_NOT_AVAILABLE_IN_CURRENCY_EXCEPTION:
        'The operation on the specified account in the selected currency is not possible',

      PACKAGE_TIME_OUT_EXCEPTION:
        'This type of installment term is not available, try creating a QR code for a different term',
      PARTNER_DICTIONARY_EXCEPTION:
        'You do not have the necessary rights to interact with this product. To connect to the product, please contact us.',
      InstallmentForbiddenException:
        "You do not have the necessary rights to view or interact with this section. Please contact your company's access authority to obtain the necessary permissions.",
      ACTIVITY_TIMEOUT_EXCEPTION: 'Could not find active partner or merchant options, please try again',

      USER_HAS_ROLE_EXCEPTION: 'The user already has this role:',
      USER_EXCEPTION: 'The account is linked to another phone number',
      EMPTY_PIN_EXCEPTION: 'The PIN/INN was entered incorrectly: the PIN/INN cannot be empty',
      WRONG_FIRST_NUM_EXCEPTION: 'The PIN/INN is entered incorrectly: the first digit must start with 1 or 2',
      WRONG_PIN_DATE_EXCEPTION: 'The PIN/INN was entered incorrectly: check the data you entered',
      WRONG_PIN_POSITION:
        'The PIN/INN was entered incorrectly: the number under the 9th position cannot consist of 1 and 5',
      TASK_REJECTED_EXCEPTION:
        'The application for the creation of an installment seller with an INN : , is being processed, please wait until the end of the application',
      PRODUCT_ROLE_POLICY_EXCEPTION: 'The user does not have roles for this operation',
      NOT_FOUND_ROLE_EXCEPTION: 'Unfortunately, the role was not found, try again later',
      DUPLICATE_TASK_EXCEPTION:
        'The application to create an installment seller with TIN: is being processed, please wait until the application is completed',
      CONTRACT_NOT_STARTED_EXCEPTION:
        'The contract with the partner has not yet commenced. Please wait until the start date of the contract according to the terms and conditions concluded',
      ILLEGAL_ARGUMENT_EXCEPTION: 'Invalid number entered. Please check and re-enter',
      LIMIT_BLOCKED_EXCEPTION: "You can transfer money only to your company's employees",
      LIMIT_BLOCKED_EXCEPTION_WHITE_LIST:
        'It’s not possible to send for signature yet — but the feature will be available soon',
      UNSUPPORTED_TYPE_OF_ACCOUNT_FOR_OPERATION_EXCEPTION:
        'Refunds to Elcart and demand accounts are not yet available',
      NOT_FOUND: '@:SHARED.RULE.CLIENT_NOT_FOUND',
      UNKNOWN: 'Error! Please try again later!',
      KNOWN: 'Error. Please try again later.',
    },

    OFFLINE: 'No internet connection',
    DOCUMENT_TEMPLATE: {
      FORBIDDEN_EXCEPTION: 'Access denied',
      LARGE_DOC_NOT_FOUND_EXCEPTION: 'File not found',
      LARGE_DOC_ALREADY_EXISTS_EXCEPTION: 'A document with the specified parameters already exists',
      LARGE_DOC_DOWNLOAD_NOT_ALLOWED_EXCEPTION: 'Unable to download the file as it does not have "Ready" status',
      NOT_FOUND_QR_PAYMENT: 'There is no data for the selected period \n Try changing the dates and try again',
      UNKNOWN: 'Error. Please try again later',
    },
    PAY_LOGIC: {
      ACTION_ERROR: 'An error occurred while performing the action. Please try again.',
      NOT_FOUND: 'Requested data not found. Please check the entered information and try again.',
      NO_DEBTS: 'No outstanding debts. All bills are paid.',
      PROVIDER_ANSWER_ERROR: 'Service provider response error. Please try again later.',
      SERVICE_BLOCKED_ERROR: 'Service is blocked. Please contact support for more information.',
      SERVICE_ERROR: 'Service error occurred. Please try again later.',
      SYSTEM_ERROR: 'A system error occurred. Please try again later.',
      VALIDATION_ERROR: 'Data validation error. Please check the entered information and try again.',
      UNKNOWN: 'Error. Please try again later',
    },
    OUTLET: {
      UNKNOWN: 'There was a technical error',
      KNOWN: 'There was a technical error',
      CASHIER_HAS_ACTIVE_SHIFT_EXCEPTION:
        'The cashier has a shift open at the sale point {salePointName} at the {cashCode}',
      CASHIER_HAS_ACTIVE_SHIFT_EXCEPTION_HINT: 'Ask the cashier to close the shift to remove it',
      DUPLICATE_SALE_POINT_NAME_EXCEPTION: 'There is already a point of sale with that name',
      ACCOUNT_SAVING_EXCEPTION: 'We couldn’t save your account. Please try again',
      ACCOUNT_SAVING_IN_ACQUIRING_EXCEPTION: 'We couldn’t save your account. Please try again',
      CASHIER_HAS_OPEN_SHIFT_EXCEPTION: 'The cashier has an open shift. Please close it to continue',
      ENTITY_NOT_FOUND_EXCEPTION: 'Unable to find the data. Please try again',
      FILE_NOT_FOUND_EXCEPTION: 'Unable to find the data. Please try again',
      SALE_POINT_EDIT_FORBIDDEN_EXCEPTION:
        'This point already has a KKM cash register. To make changes, please remove the KKM cash register first',
      TAX_ATTRIBUTE_SAVING_EXCEPTION: 'Enter the tax office and the point’s coordinates to proceed',
    },
    STATEMENT: {
      PERIOD_IS_LIMITED_BY_1_YEAR: 'The maximum statement download period is 1 year',
      UNKNOWN: 'Unable to create statement',
    },
  },
  LOAN_CLAIMS: {
    TITLE: 'Loans',
    SOON: 'Loans coming soon',
  },
  QR_CODE: {
    CREATE_QR: 'Create QR Code',
    MY_QR_CODE: 'My QR Code',
    RECEIVING_FUNDS: 'Receiving payments from any bank',
    TITLE: 'QR Code',
    SELECT_ACCOUNT: 'Credit account',
    COMMISSION: 'Payment acceptance fee 0.2%',
    DOWNLOAD: 'Download QR',
    PRINT: 'Print QR',
    BLACK_AND_WHITE_A4: 'Black & white A4',
    BLACK_AND_WHITE_A5_A6: 'Black & white A5, A6',
    COLOR_A4: 'Color A4',
    COLOR_A5_A6: 'Color A5, A6',
    SAVE_CHANCE: 'Save changes',
    CANCEL_CHANCE: 'Cancel changes',
    EMPTY_CARD: 'No accounts or cards available',
    OPEN_ACCOUNT_CARD: 'Open a settlement account or Visa Business card at an Optima Bank branch',
    SHARE: 'Share',
    CARD_ACCOUNTS: 'Card Accounts',
    SETTLEMENT_ACCOUNTS: 'Settlement Accounts',
    NO_ACCESS_ACCOUNT: 'No access to the account',
    GET_ACCESS: 'Contact your management to gain access',
    NO_CARD: 'No cards available',
    OPEN_CARD: 'Contact your management to gain access',
    FORBIDDEN: 'No access to the store’s credit account',
    GET_ACCESS_SALE: 'Contact the company owner to gain access',
    OPEN_ACCESS:
      'Grant access to the account: "Settings" → "Users" → Select employee → Select settlement account → Enable "Create QR"',
    ON_ACCOUNT: 'To account',
    ON_SALE_POINT: 'To sale point',
    EMPTY_SALE_POINT: 'Create a point of sale to generate a QR code',
    ASK_SALE_POINT: 'To generate a QR code, request your supervisor to add a point of sale',
    TAB_SALE_POINT: 'QR to the point',
    TAB_PERSONAL: 'Personal QR',
    PURPOSE: 'Purpose',
    PURPOSE_HINT: 'In the purpose, you can specify what or for whom the payment is for',
    ALLOW_EDIT_AMOUNT: 'Allow editing of amount',
    ALLOW_EDIT_AMOUNT_HINT: 'After activation, the payer will be able to change',
    WITH_PURPOSE_TITLE: 'QR with purpose and\n specified amount',
    WITH_PURPOSE_SUBTITLE: 'Create personal QR codes\n for each client or service',
    WITH_PURPOSE_ITEM_TITLE: 'Payment purpose',
    WITH_PURPOSE_ITEM_TEXT:
      'You create a QR code for the client with the payment purpose — what for, for whom, and for what amount',
    NO_MANUAL_INPUT_TITLE: 'Payment without manual input',
    NO_MANUAL_INPUT_TEXT: 'The client scans the QR and the payment is generated automatically',
    HISTORY_TITLE: 'Payment history',
    HISTORY_TEXT:
      'In the payment history you will see the purpose you specified and it will be clear what the funds were transferred for',
    WHAT_IS_PERSONAL_QR: 'What is a personal QR code?',
  },
  CARD: {
    TITLE: 'Cards',
    BLOCK: 'Block Card',
    SETTINGS: 'Settings',
    HISTORY: 'History',
    LIMIT: 'Limits',
    LIMIT_TITLE: 'Select limit type',
    BLOCK_PAYMENT_CARD: 'You are about to block your payment card',
    ARRESTED: 'Unblock',
    FINAL_ARRESTED: 'Blocked',
    AVAILABLE_BALANCE: 'Available Balance',
    RULE: 'The total amount of all limits on all cards cannot exceed 5,000,000.00 KGS. \nPlease review other limits.',
    EMPTY_CARD: 'No available cards',
    EMPTY: 'No data for this period',
    YOUR_CARD_IS_BLOCKED: 'Your card is blocked.',
    YOUR_CARD_IS_BLOCKED_DESCRIPTION: 'To unblock it, please visit an Optima Bank branch.',
    COMMISSION: 'Commission',
    FILTER_HINT: 'To obtain a statement for dates earlier than 13.02.2025, please contact a branch.',
    INFORMATION: {
      CARD_ACCOUNT: 'Card Account',
      ALL: 'All',
      REPLENISHMENT: 'Replenishment',
      FILTER: 'Filter',
      WRITE_OFF: 'Debits',
      SET: 'Apply',
      THREE: 'Last 3 days',
      WEEK: 'Last week',
      MONTH: 'Last 30 days',
      TOTAL_RECEIPTS: 'Total Inflows',
      TOTAL_WRITE_OFF: 'Total Debits',
      PERIOD_START_BALANCE: 'Balance at the beginning of the period',
      PERIOD_END_BALANCE: 'Balance at the end of the period',
      EMPTY: 'No data for the period',
    },
    BLOCK_CARD: {
      LOSS: 'Card Lost',
      THEFT: 'Card Stolen',
      COMPROMISING: 'Card Compromised',
      TEMPORARY: 'Temporary Block',
      TEXT: 'After blocking, the card will no longer be available for transactions. You can unblock the card at Bank branches. If the card is lost or you suspect a data leak, we recommend reissuing the card.',
      BLOCK: 'Block Card',
    },
    RENAME: {
      RENAME_CARD: 'Rename Card',
      NAME_CARD: 'Card Name',
      SET_NAME: 'Rename',
      DESIRED_NAME: 'Enter desired card name',
      SUCCESS: 'Card name changed successfully',
    },
    SHARED: {
      SET: 'Set',
      RESET: 'Reset',
      LIMIT_IN_DAY: 'Daily Limit (KGS)',
      DATE_TO: 'End Date',
      DATE_FROM: 'Start Date',
      AVAILABLE_AMOUNT: 'Available Amount',
      AVAILABLE_AMOUNT_TRANSACTION: 'Available Number of Transactions',
      AVAILABLE_AMOUNT_TRANSACTION_IN_DAY: 'Transactions per Day',
      AVAILABLE_OUT_OF: 'Available {available} of {outOf}',
      MAIN_BALANCE: 'Main Balance',
      CARD_ACCOUNT: 'Card Account',
      CARD: 'Card',
      NOT_HAVE_CARD_ACCOUNT: 'You don’t have a card account',
    },
    CASH_LIMIT: 'ATM and POS Terminal Cash Withdrawals',
    RETAIL_CARD_PRESENT: 'Non-cash purchases via POS Terminals',
    CARD_NOT_PRESENT: 'Online Purchases/Payments',
    ONLINE_PAYMENTS: 'Online Payments',
    FUNCTIONALITY_NOT_APPLY_RECURRING_PAYMENT: 'This feature does not apply to recurring payments',
    OPERATION_ALLOWED: 'Operations allowed',
    DIALOG: {
      LIMIT: {
        SETTING: 'Setting limit...',
        SUCCESS: 'Limit set successfully',
        ERROR: 'Error, please try again later',
      },
      BLOCK: {
        SETTING: 'Setting block...',
        SUCCESS: 'Card successfully blocked',
        ERROR: 'Error, please try again later',
      },
      UNLOCK: {
        SETTING: 'Unblocking card...',
        SUCCESS: 'Card successfully unblocked',
        ERROR: 'Error, please try again later',
      },
    },
    SETTINGS_USER: {
      VIEW_CARD: 'View Card',
      BLOCK: 'Block/Unblock',
      LIMITS: 'Set Limits',
      DETAILS: 'View Limits',
      SUCCESS: 'Card settings updated',
      VIEW_ACCOUNT: 'View Card Account',
      CARD_ACCOUNTS: 'Card Accounts',
      NOTIFICATION_QR: 'QR Transfer Push Notifications',
      GENERATE_QR: 'Create QR',
    },
  },
  POS: {
    STATEMENT: 'Statements on POS',
    TITLE: 'POS Terminals',
    BANNER: {
      TITLE: 'Order a terminal',
      LABEL: '{value}% commission on Optima and Elcart cards',
    },
    DIALOG: {
      CONFIRM_CLOSE: {
        TITLE: 'Do you want to exit?',
        LABEL: 'Draft application will not be saved',
      },
    },
    QUESTIONS: {
      TERMINALS_COUNTS: 'How many terminals would you like to order?',
      ACCOUNT: 'Which account should receive sales funds?',
      ADDRESS: 'Where will the terminal be installed?',
      USER: 'Who is responsible for the sales point?',
      WORKING_DAYS: 'What are your working days?',
    },
    ONBOARDING: {
      TERMINAL: {
        HEADER: 'Accept card and QR payments',
        SUB_HEADER: 'The terminal supports Visa, Mastercard, UnionPay, and Elcart',
        COMMISSION: '{value}% commission',
        COMMISSION_HINT: 'For Optima and Elcart cards',
        CARD_HINT: 'For other banks and systems',
        DELIVERY: 'Fast delivery',
        DELIVERY_HINT: 'Within three days',
        FLEX_COMMISSION: 'Flexible commissions for payments',
        ABOUT_TARIFF: 'More about tariffs',
      },
      PHOTO: {
        HEADER: 'Prepare two photos of the point of sale for the application',
        SUB_HEADER: 'You can take the photos during the application or in advance — whichever is more convenient',
        EXPECTATION: 'What we expect in the photos',
        OUTSIDE: 'Outside',
        OUTSIDE_HINT: 'Shows the sign and entrance',
        INSIDE: 'Inside',
        INSIDE_HINT: 'Shows the counter and the interior',
      },
      AGREEMENT: {
        LABEL: 'By clicking "Submit Application", you agree to the',
        LINK: 'terms of the agreement',
      },
    },
    ORDER: {
      TITLE: 'Terminal Application | Terminal Applications',
      SUB_TITLE: 'Order a Terminal',
      APPLICATION: 'Application | Applications',
      SUBMIT_APPLICATION: 'Submit Application',
      ADD_KKM: 'Add Cash Register (KKM) to Order',
      ENROLLMENT_ACCOUNT: 'Receiving Account',
      STORE_NAME: 'Store Name',
      OFFER_TYPES: 'Your Products or Services',
      HAS_SECURITY: 'Cameras or security on site',
      FRONT_PHOTO: 'Upload outside photo of the point of sale',
      FRONT_PHOTO_DOWNLOADED: 'Outside photo uploaded',
      BACK_PHOTO: 'Upload inside photo of the point of sale',
      BACK_PHOTO_DOWNLOADED: 'Inside photo uploaded',
      WORKING_DAYS_HINT: 'Select one or more days to specify the schedule',
      OPENING: 'Opening',
      CLOSING: 'Closing',
      ADD_SCHEDULE: 'Add Schedule',
      DELETE_SCHEDULE: 'Delete Schedule',
      SUBMIT: 'Send Application',
      SENT_TO_REVIEW: 'Sent for review',
      SENT_HINT: 'You can track the status in the "Applications" section',
      TO_APPLICATIONS: 'To Applications',
    },
    ABOUT_KKM: {
      TITLE: 'What is a Cash Register?',
      SUB_TITLE: 'Cash Register or KKM',
      LI_1: 'helps track sales',
      LI_2: 'prints fiscal receipts',
      LI_3: 'automatically sends data to the tax authority',
      FOOTER: 'Add a KKM to your order to reduce paperwork',
    },
    RULE: {
      INVALID_PHOTO_EXTENSION:
        'File type not allowed. Allowed types: .heic .png .jpeg\nPlease delete the file and upload a file of an allowed type.',
      FILE_LARGE_ERROR:
        'The file you uploaded exceeds the maximum size of 5MB.\nPlease delete the file and upload a smaller one.',
    },
    STATUS: {
      COMPLETED: 'Approved',
      IN_PROCESS: 'Consider',
      REJECTED: 'Rejected',
      REJECT_REASON: 'Reason for rejection',
    },
    TASKS: {
      TITLE: 'Applications',
      STORE_NAME: 'Point of Sale',
      TERMINALS_COUNT: 'Number of Terminals',
      CREATE_DATE: 'Application Date',
      ERROR: 'Failed to retrieve applications',
    },
    DETAILS: {
      TERMINALS: 'Terminals',
      TO_ORDER: 'To Order',
      KKM: 'Cash Register (KKM)',
      PLACE: 'Point of Sale',
      NAME: 'Name',
      OFFER_TYPES: 'Products or Services',
      RESPONSIBLE_PERSON: 'Responsible Person',
      WORK_SCHEDULE: 'Work Schedule',
      ERROR: 'Failed to retrieve application details',
    },
  },

  SALARY: {
    ONBOARDING: {
      TITLE: 'Trust payroll to the bank: save on fees and forget the routine.',
      CONNECT: 'Connect',
      FEE_FREE: { TITLE: '0% Fees', DESCRIPTION: 'Transfers to employees are completely free.' },
      INSTANT_CREDIT: {
        TITLE: 'Instant crediting',
        DESCRIPTION: 'Funds are credited to cards right after the statement is signed.',
      },
      SUPPORT: { TITLE: 'Reliable support', DESCRIPTION: 'We provide full support.' },
      ANYTIME: { TITLE: 'Credit 24/7', DESCRIPTION: 'Send the statement anytime, around the clock.' },
      STEP_TWO: {
        TITLE: 'Visit the bank office where you opened your settlement account',
        SUBTITLE:
          'Connecting to the payroll card program takes a little time. Once connected, you will be able to credit salaries to employees conveniently through Optima Business.',
        ADDRESS_LABEL: 'Bank office address',
        IMPORTANT: 'Important! Bring your passport and the company documents you need.',
      },
    },
    BANNER: {
      TITLE: 'Credit salaries directly from your checking account',
      INFO: 'Create payroll sheets on the website without prior transfers to a transit account or using Excel files',
    },
    DELETE_ALL: 'Delete all',
    LOADING_CHANGE_SETTINGS: 'Loading...',
    SUM: 'Amount',
    TOTAL: 'Total',
    WITHDRAWAL_ACCOUNT: 'Write-off account',
    CODE_COMPANY: 'Company code',
    NAME_COMPANY: 'Company name',
    ACCOUNT_NUMBER: 'Settlement account number',
    AMOUNT_CREDIT: 'Amount credited to card accounts',
    SELECT_TEMPLATE: 'Choose from templates',
    CREATE_SALARY: 'Create statement',
    UPLOAD_TEMPLATE: 'Load Excel statement',
    EMPLOYEES: 'Employees',
    IN_REVIEW: 'Being varified',
    TO_STATEMENTS: 'To the list of statements',
    CREDITED_AMOUNT: 'Credit amount',
    SEND_STATEMENT: 'Send for verification',
    ADD_STATEMENT: 'Add statement',
    DOWNLOAD_TEMPLATE: 'Download Excel template',
    SELECTED_EMPLOYEE: 'Selected employees',
    ID_COMPANY: 'Company ID',
    TRANSFER_ACCOUNT: 'Account to be credited',
    SELECT_ALL: 'Select all',
    ADD_EMPLOYEE: 'Add employee',
    ADD_TEMPLATE: 'Add to template',
    AMOUNT_COMMISSION: 'Commission amount',
    TOTAL_SUM: 'Total amount',
    COMPANY_NAME: 'Company name',
    TRANSIT: 'Transit account',
    RKO: 'Settlement account',
    STATEMENT_NAME: 'Statement name',
    NOT_CONNECTED_SALARY: 'Payroll card program was not connected',
    IMPORT: 'Download statement',
    CAUSE: 'Cause',
    TOTAL_AMOUNT: 'Total amount',
    BACK_TO_SALARY: 'Return to Payroll card program',
    DELETE_STATEMENT: 'Statement is deleted',
    DELETING_STATEMENT: 'The payroll deletion is in progress ...',
    INFO: {
      TITTLE: 'The entire journey from uploading the statement to crediting employees consists of the following steps:',
      SUB_TITTLE:
        '1) Upload a correctly completed statement. It is important to use an approved template!\n2) Next, the statement goes to the 1st stage, where the system automatically checks the statement for correctness of filling, activity of employee cards and the balance on the debit account.\n3) When the status "Processed" is received on the 1st stage, the statement gets to the 2nd stage in the status "Ready for signing", after which it is required to send it for signing by 17:00 and sign it by 17:25. The status "Completed" means that the funds have been credited to the employees.',
    },
    MORE_DETAILS: 'More details',
    TITLE: 'Payroll card program',
    ATTACHED_FILE: 'Attached file',
    PAY_CONTROL_NOT_AVAILABLE:
      'It is impossible to send statement for signing. One of the signers does not have PayControl.',
    TABS: {
      EMPLOYEE: 'Employees',
      STATEMENT: 'Statement',
    },
    FAQ: {
      TITLE: 'FAQ – Payroll Project',
      VIDEO: 'Watch the video guide',
      TOPICS: {
        CREATE: {
          TITLE: 'Creating a Payroll Register',
          WHEN: {
            TITLE: 'When to use',
            TEXT: 'Use this if you need to manually create and send a payroll register to your employees.',
          },
          STEPS: {
            TITLE: 'Steps',
            ITEM: {
              1: 'Go to Payroll Project → Registers.',
              2: 'Select Add register → Create register.',
              3: 'Select the debit account.',
              4: 'Add employees and enter the payment amounts.',
              5: 'Once completed, the register status will change to Ready to sign.',
              6: 'Open the register and select Submit for signature.',
              7: 'Go to Payments to sign.',
              8: 'Select the register and select Sign.',
            },
          },
          EXTRA: {
            TITLE: 'Additional features',
            ITEM: {
              1: "Once the register is completed, you can download a PDF document with the bank's stamp.",
              2: 'For recurring payments, select Repeat — the system will automatically fill in the employees and amounts from the previous register.',
            },
          },
        },
        EXCEL: {
          TITLE: 'Uploading a Payroll Register via Excel',
          NOTICE:
            'Important! If the register status changes to Rejected, check that the Excel template is filled in correctly and upload it again.',
          WHEN: {
            TITLE: 'When to use',
            TEXT: 'Use this if you need to upload employee data in bulk from an Excel file.',
          },
          STEPS: {
            TITLE: 'Steps',
            ITEM: {
              1: 'Go to Payroll Project → Registers.',
              2: 'Select Download Excel template.',
              3: 'Fill in the employee data in the template.',
              4: 'Save the file to your device.',
              5: 'Select Upload register.',
              6: 'Select the completed Excel file.',
              7: 'Once uploaded successfully, the register status will change to Ready to sign.',
              8: 'Open the register and select Submit for signature.',
              9: 'Go to Payments to sign.',
              10: 'Select the register and select Sign.',
            },
          },
          REQUIREMENTS: {
            TITLE: 'Excel template requirements',
            ITEM: {
              1: 'Do not change the file formatting.',
              2: 'Do not delete the formulas.',
              3: 'Do not leave empty rows.',
              4: 'Keep the template structure unchanged.',
            },
          },
          EXTRA: {
            TITLE: 'Additional features',
            ITEM: {
              1: "Once the register is completed, you can download a PDF document with the bank's stamp.",
              2: 'For recurring payments, use the Repeat button.',
            },
          },
        },
        CONNECT_EMPLOYEE: {
          TITLE: 'Enrolling an Employee in the Payroll Project',
          NOTICE:
            'Important! Before enrolling the employee, make sure they have been added to the system and have the necessary access rights.',
          WHEN: {
            TITLE: 'When to use',
            TEXT: 'Use this if you need to give an employee access to the payroll project.',
          },
          STEPS: {
            TITLE: 'Steps',
            ITEM: {
              1: 'Go to Settings → Users.',
              2: 'Select the employee.',
              3: 'Turn on the Payroll Project toggle.',
            },
          },
          RESULT: {
            TITLE: 'Result',
            ITEM: {
              1: 'Once enrolled, the employee will have access to a checking account under the payroll project.',
              2: 'If the toggle is turned off, access to the payroll project will be closed.',
            },
          },
        },
        ERRORS: {
          TITLE: 'Payroll Register Errors',
          NOTICE:
            'Recommendation. Before resubmitting, check that the employee data, payment amounts, and selected debit account are correct.',
          WHEN: {
            TITLE: 'When to use',
            TEXT: 'Use this if a register has been rejected or failed to process.',
          },
          REASONS: {
            TITLE: 'Reasons for errors',
            ITEM: {
              1: {
                TERM: 'Rejected by the First Approver',
                TEXT: 'The document was rejected at the signing stage.',
              },
              2: {
                TERM: 'Signature deadline expired',
                TEXT: 'The document remained pending signature for too long.',
              },
              3: {
                TERM: 'Failed validation',
                TEXT: 'Errors or incorrect data were found in the register.',
              },
              4: {
                TERM: 'Rejected by the bank',
                TEXT: "The document failed processing on the bank's side.",
              },
            },
          },
          RETRY: {
            TITLE: 'Resubmitting a Register',
            ITEM: {
              1: 'Open the register with the error.',
              2: 'Select Repeat.',
              3: 'The system will automatically restore: the debit account; the list of employees; the payment amounts.',
              4: 'Make changes if needed.',
              5: 'Select Submit for review.',
            },
          },
        },
      },
    },
    EMPLOYEE: {
      EMPTY: 'The list is empty',
      FILTER_EMPTY: 'No employee with specified parameters was found',
      SEARCH_PLACEHOLDER: 'Search Employee',
      PAY_CONTROL_NOT_AVAILABLE: 'Employee actions are unavailable. One of the signers does not have PayControl.',
      ADD: {
        INN: 'Employee TIN',
        INN_ERROR: 'Enter the 14-digit TIN',
        LIMIT: 'A document can contain no more than {count} employees',
        TO_ADD: 'Employees to add:',
        ACCOUNT_REQUIRED: 'Select an account',
        SEARCH_RESULTS: 'Search results',
        ALREADY_ADDED: 'This employee has already been added',
        ALREADY_IN_PROJECT: 'The employee is already a participant of this payroll project.',
        CARD_NUMBER: 'Card number',
        ACCOUNT: 'Account',
        NO_CARDS: 'This employee has no cards available for salary crediting',
        LOADING_CARDS: 'Loading cards...',
        NOT_FOUND: 'No employee found for this TIN.',
        SAVE_CHANGES: 'Save changes',
        SEND_FOR_SIGNING: 'Send for Signature',
        SUCCESS: 'The employee will be added to the payroll project after confirmation by the First Approver.',
        SUCCESS_BULK: 'The employees will be added to the payroll project after confirmation by the First Approver.',
        GOT_IT: 'Got it',
        SELECT_ACCOUNTS: 'Select a card for all employees',
        EMPTY_LIST: 'Add at least one employee',
      },
      EDIT: {
        SENT_BUTTON: 'OK',
        TITLE: 'Edit Employee',
        NO_CARDS: 'The employee has no available cards',
        SAME_ACCOUNT: 'The new account is the same as the current one',
        SENT_MESSAGE: 'The credit account will be updated after the changes are confirmed by the First Approver.',
      },
      RESTORE: {
        ACTION: 'Restore',
        CONFIRM_TITLE: 'Restore this employee to the payroll project?',
        CONFIRM_TITLE_BULK: 'Restore the selected employees to the payroll project?',
        SENT_MESSAGE: 'The employee will be added back to the salary project once the first signer confirms it.',
        SENT_MESSAGE_BULK:
          '{count} employees will be added back to the salary project once the first signer confirms it.',
        RESET_SELECTION: 'Clear selection',
      },
      DELETE: {
        CONFIRM_TITLE: 'Remove this employee from the payroll project?',
        CONFIRM_TITLE_BULK: 'Remove the selected employees from the payroll project?',
        SENT_MESSAGE: 'Once the first signer confirms it, the employee will be removed from the salary project.',
        SENT_MESSAGE_BULK:
          'Once the first signer confirms it, {count} employees will be removed from the salary project.',
      },
      FILTER: {
        TITLE: 'Filter and sorting',
        BY_CREATED_DATE: 'By Date Added',
        NEWEST_FIRST: 'Newest First',
        OLDEST_FIRST: 'Oldest First',
        APPLY: 'Apply',
        RESET: 'Reset All',
      },
      CHIPS: {
        ADDED: 'Added',
        FOR_SIGNING: 'Pending signature',
        DELETED: 'Removed',
        REJECTED: 'Rejected',
      },
      ERROR: {
        TITLE: "Employees' data loading failed.",
      },
      STATUS_LABEL: {
        EMPLOYEE_IN_PROCESSING_BANK: 'In processing by the bank',
        EMPLOYEE_ERROR_CREATED: "Couldn't add employee",
        EMPLOYEE_REJECTED: 'Rejected by the First Approver',
        EMPLOYEE_CLOSED: 'Removed',
        EMPLOYEE_CARD_NOT_LINKED_YET: "The card hasn't been linked yet",
        EMPLOYEE_CARD_FAILED_ADD: "Couldn't add a card",
        EMPLOYEE_CARD_BLOCKED: 'Card Blocked',
        EMPLOYEE_CARD_SUCCESS: 'Employee Added',
        EMPLOYEE_AWAITING_CREATION: 'Pending Addition',
        EMPLOYEE_AWAITING_EDIT: 'Pending Edit',
        EMPLOYEE_AWAITING_CLOSING: 'Pending Removal',
        UNKNOWN: 'Unknown status',
      },
    },
    STATEMENT: {
      DIALOG: {
        RETURN: 'Back',
        SALARY_RELOADING: 'Process of restarting the statement is in progress...',
        STATEMENT_IS_REJECTED: 'Process of rejecting the statement is in progress...',
        STATEMENT_REJECTED: 'Statement was rejected',
        SENDING_STATEMENT: 'Process of sending statement for signing is in progress...',
        STATEMENT_SENT: 'Statement was successfully sent',
        STATEMENT_SIGNED: 'Statement was successfully signed.',
        STATEMENT_IS_SIGNED: 'Statement for the amount "{sum} {currency}" is in the process of signing....',
      },
      COLUMN_TABLE: {
        NUMBER: 'No',
        FILE_NAME: 'Name',
        TOTAL_AMOUNT: 'Total amount',
        NUMBER_CARD: 'Card Account Number',
        DOWNLOAD_DATE: 'Creation date ',
      },
      EMPTY: 'There are no downloaded statements',
      ERROR: {
        TITLE: 'An error occurred while statement downloading',
      },
    },
    CONTRACT: {
      TITLE: 'Information on payroll agreement',
      ID: 'Payroll card program ID:',
      ACCOUNT: 'Transit account:',
      STATUS_LABEL: {
        CONTRACT_ON_VERIFICATION: 'Transit account',
        CONTRACT_VERIFICATED: 'Contract was verified by the verifier',
        CONTRACT_REJECTED: 'Contract was rejected by the verifier',
        CONTRACT_PENDING_CLOSURE: 'Contract pending closure',
        CONTRACT_CLOSED: 'Contract was closed',
        CONTRACT_PENDING_UNCLOSE: 'Contract was closed',
      },
    },
    DOWNLOAD: {
      TEXT: 'Download template',
      ERROR: 'An error occurred while statement downloading.',
      ERROR_HELP: 'Please try again by clicking the button "Download again".',
      DOWNLOADING_STATEMENT: 'The statement is being downloaded',
    },
    ERROR: {
      TITLE: 'An error occurred while statement downloading.',
      MIN_AMOUNT: 'Enter an amount from 1 {currency}',
      MAX_AMOUNT: 'Enter an amount up to 1,000,000,000 {currency}',
      BALANCE_IS_LESS_AMOUNT_ERROR: 'Insufficient funds in the account',
    },
    NOTIFICATION: {
      STATUS: {
        ERROR: {
          TEXT: 'Bank rejected the payroll statement. Currency {amount} {currency}.',
        },
        SUCCESS: {
          TEXT: 'Bank approved the payroll statement. Currency {amount} {currency}.',
        },
      },
    },
  },
  LETTER: {
    DOWNLOAD: {
      ERROR: 'Error occurred while downloading a file',
      ERROR_HELP: 'Please click Download button again',
    },
    TITLE: 'Messages',
    ATTACHED_FILE: 'Attached file',
    CREATED: 'Created by: ',
    REVOKE: 'To decline',
    SIGN: 'To sign',
    FOR_SIGN: 'To be signed',
    DELETE: 'Delete',
    NOTIFICATION: {
      TITLE: 'New message from bank',
      TEXT: 'Reply received from bank to your message №{number}',
    },
    EMPTY: {
      OUTGOING: 'You have no messages in your outbox',
      INCOMING: 'You have no messages in your inbox',
    },
    ERROR: {
      TITLE: 'Error occurred while downloading messages',
    },
    NAV: {
      OUTGOING: 'Outbox',
      INCOMING: 'Inbox',
    },
    CREATE: {
      CREATE_LETTER: 'Create message',
      DATE: 'Creation date',
      NAME_COMPANY: 'Company name',
      TOTP: 'Please enter TOTP code to confirm sending a message to bank',
      ENTER_TOTP: 'Enter TOTP code',
      SELECT: {
        SUBJECT: 'Subject',
        SUBJECT_EMPTY: 'Click to select a subject for a message',
        MONEY_TRANSFER: 'Money transfer documents',
        PAYMENT_CANCELLATION: 'Payment cancellation',
        PERSONAL_DOCUMENT: 'Documents',
        OTHER: 'Other',
      },
      ENTER_SUBJECT: 'Enter your message subject',
      ENTER_TEXT: 'Enter message',
      ATTACH_FILE: 'Attach file',
      ALLOWED_TYPES: '(10 MB, allowed file types: .xls .xlsx .doc .docx .pdf .jpg .png .pptx .zip .txt)',
      FOR_SIGN: 'To be signed',
      RULES: {
        ENTER_SELECT: 'Select subject of a message from this drop-down list',
        ENTER_TEXT: 'Write a message in this field',
        ENTER_OTHER_TEXT: 'Write a subject of the message in this field',
        INVALID_EXTENSION: {
          FIRST:
            'A file of unsupported type is attached. Allowed file types: .xls .xlsx .doc .doc .docx .pdf .jpg .png .pptx .zip .txt',
          SECOND: 'Please delete attachement and add a file of allowed type',
        },
        FILE_LARGE: {
          FIRST: 'Size of your attachement exceeds maximum allowed file-size of 10 MB',
          SECOND: 'Please delete attachement and add a smaller file',
        },
        INVALID_TOTP: 'You entered invalid TOTP code. Please enter correct TOTP code again',
        INVALID_CHARACTER_TITLE: 'You used invalid characters in the subject line of the message: ',
        INVALID_CHARACTER_MESSAGE: 'You used invalid characters in this field: ',
      },
      DIALOG: {
        SENDING: 'Sending a message',
        REPEAT: 'Repeat',
        NOT_SEND: 'Message was not sent',
        COME_BACK: 'Return',
        SENT_FOR_SIGN: 'The letter has been sent for signature',
        COME_BACK_LETTER: 'Return to messages',
        ERROR_AFTER_DRAFT: 'Failed to send the letter for signature. The letter has been saved as a draft',
        SUCCESS_DELETE: 'The message has been deleted',
        FAILED_DELETE: 'Failed to delete message',
        SAVED_TO_DRAFT: 'Message saved as draft',
        FAILED_SAVED_TO_DRAFT: 'Failed to save the message as draft',
        FAILED_SEND_FOR_SIGN: 'Failed to send the letter for signature',
        SIGN_LETTER: 'Message signed',
        FAILED_SIGN_LETTER: 'Failed to sign the message ',
        SUCCESS_REVOKE: 'Message rejected',
        FAILED_REVOKE: 'Failed to reject message',
      },
    },
    STATUS: {
      OUTGOING: {
        NOT_PROCESSED: 'Not processed',
        IN_PROCESSING: 'In processing',
        PROCESSED: 'Processed',

        ON_VERIFICATION: 'To be signed',
        FIRST_SIGN_IN_PAY_CONTROL: 'To be signed',
        TIMEOUT_CANCELED_SIGN_ONE: 'Timeout cancellation',
        CANCELED_SIGN_ONE: 'Canceled',
        DRAFT: 'Draft',
      },
      INCOMING: {
        NOT_PROCESSED: 'New message',
        PROCESSED: 'Read',
      },
    },
  },

  OUTLET: {
    LUNCH_BREAK: 'Lunch',
    NEW_POINT: 'New sales point',
    CASH_ADD: 'Add cash register',
    POINT_ADD: 'Add sales point',
    CASH: 'Cash register',
    SALE_POINTS: 'Sales points',
    SALE_POINT: 'Sales point',
    ALL_POINTS: 'All points',
    EMPLOYEES: 'Cashiers',
    CREATE_QR: 'Create QR code',
    SHOW_ALL: 'Show all',
    QR_CODE: 'QR code',
    NAME: 'Name',
    DELETE_ALL: 'Delete all',
    SELECT_ALL: 'Select all',
    ADD_EMPLOYEE: 'Add cashier',
    ADD_ADDRESS: 'Add address',
    ADD_PHONE: 'Add phone number',
    CHANGE_ACCOUNT_SETTINGS: 'Change account access in Settings',
    SORT_NEWEST: 'Newest first',
    SORT_OLDEST: 'Oldest first',
    SORT_ALPHABETICALLY: 'Alphabetically',
    NEW_CASH: 'New cash register',
    GRANT_ACCESS: 'Grant access',
    EMPTY_EMPLOYEES: 'No cashiers yet',
    EMPTY_SEARCH_EMPLOYEES: 'No cashiers with that name',
    EMPTY_SEARCH_POINT: 'No points with that name',
    POINT_ACCESS_DENIED: 'No access to sales points',
    CASH_ACCESS_DENIED: 'No access to cash registers',
    EMPLOYEE_ACCESS_DENIED_CASH: 'Cashier has no access to cash registers',
    EMPTY_CASHES: 'No registers with that number',
    ONBOARDING: {
      HEADER: 'Add a sales point',
      SUB_HEADER: 'You’ll be able to track sales and add cashiers in the app',
      QR: 'Create a QR code for each cash register',
      HISTORY: 'View sales history by point and register',
      ACCESS: 'Grant access to cashiers so they can view history',
      ADD_POINT: 'Add sales point',
    },
    REVOKE_ACCESS: 'Revoke access',
    EDIT_WITH_KKM: 'The point has a cash register. To change the data, you need to delete the KKM checkout',
    FORM: {
      QUESTIONS: {
        NAME: 'What is the name of the sales point?',
        ACCOUNT: 'Where should funds be credited?',
        ADDRESS: 'Add address',
        PHONE: 'How can we contact the point?',
        SOCIAL: 'Links to the address and social networks of the point',
      },
      POINT_NAME: 'Sales point name',
      CHECK_NAME: 'Receipt name',
      CHECK_HINT: 'Enter the name in Latin — it will appear on sales receipts',
      ACCOUNT_HINT: 'If you change the credit account, create a new QR code',
      REGION: 'Region',
      CITY: 'City or regional center',
      DISTRICT: 'District or village',
      ADMINISTRATIVE_TERRITORY: 'Administrative territory',
      IN_BUILDING: 'In building',
      NEARBY: 'Nearby',
      COMPANIES_IN_BUILDING: 'Select organization',
      STREET_OR_MKR: 'Street or microdistrict',
      HOUSE: 'Building',
      POSTAL_CODE: 'Postal code',
      TRADE_CENTER_OR_MARKET_POINT: 'Trade center or market point',
      WORKING_HOURS: 'Working hours',
      WORKING_FROM: 'From',
      WORKING_TO: 'To',
      SELECTED_COMPANY: 'Selected company',
      NEARBY_COMPANIES: 'Nearby companies',
      MAP_PICKER_TITLE: 'Add address',
      ADDRESS_SEARCH_PLACEHOLDER: 'Enter company address',
      CURRENT_LOCATION: 'Current location',
      GEOLOCATION_ERROR: 'Could not detect current location',
      LOAD_MORE_COMPANIES: 'Show more',
      COMPANY_BRANCHES_LOAD_ERROR: 'Could not load companies. Please try again',
      ORGANIZATION_BRANCHES: 'Organization branches',
      SELECT_BRANCH: 'Select a branch',
      SUGGEST_ORG_BRANCHES: '{count} branches, {city}',
      ADDRESS_NOT_FOUND: 'Address not found',
      TWO_GIS_NOT_FOUND: 'Nothing was found. Try refining your search',
      ADD_PHONE: 'Add phone number',
      PHONES: 'Phone numbers',
      TWO_GIS: "Link to the location's address in 2GIS",
      TWO_GIS_SHORT: '2GIS',
      COPY_LINK: 'The link is copied',
      ENTER_TWO_GIS: 'Insert a link to 2GIS',
      SOCIAL_NETWORK: 'Links to the address and social networks of the point',
      SOCIAL_NETWORK_SHORT: 'Social media',
      PLACED_IN_MALL: 'Point in a shopping center or market',
      ADD_SOCIAL_NETWORK: 'Add',
      ENTER_SOCIAL_NETWORK: 'Insert a link to a social network',
      MALL: 'Shopping mall',
      MALL_NAME: 'Shopping center name',
      FLOOR: 'Floor',
      BOUTIQUE: 'Boutique number',
      MARKET: 'Market',
      MARKET_NAME: 'Market name',
      MARKET_ROW: 'Row',
      CONTAINER: 'Container',
    },
    RULE: {
      SAME_PHONE: 'This number already exists. Enter a different number',
      ACCOUNT_FORBIDDEN: 'No access to the account',
    },
    DIALOG: {
      POINT_IS_READY: 'Point "{name}" is ready to operate',
      ADD_MORE_POINT: 'Add another point',
      TO_POINT_LIST: 'To point list',
      CHANGE_ACCOUNT: {
        TITLE: 'The deposit account will be changed for all points of sale',
        DESCRIPTION:
          'All points under contract №{number} share a single account — if you change it, it will be updated across all points:',
      },
      QT_HINT_INVITED:
        'Send the link and the QR code. When the cashier logs into Optima Business, allow him access in the "Cashiers" section',
      QR_HINT:
        'QR codes will continue to work, but the money will go to a different account. Create new QR codes to change the credit account',
      CASH_IS_READY: 'Cash register {code} is ready to operate',
      CASH_IS_READY_HINT: 'It is available in "{name}"',
      ADD_MORE_CASH: 'Add another register',
      TO_CASH_LIST: 'To register list',
      REVOKE_ACCESS_TITLE: 'Revoke access to all registers?',
      REVOKE_ACCESS_MESSAGE: '{name} will no longer be able to track sales',
      DO_YOU_WANT_REVOKE: 'Do you want to revoke access to all registers?',
      FINISH_CHANGES_TO_REVOKE: 'Finish changes and press "Revoke access"',
      DELETE_CASHIER: 'Delete cashier "{name}"?',
      DELETE_CASHIER_MESSAGE: 'Cashier {name} will no longer be able to log into Optima Business',
      CASHIER_DELETED: 'Cashier deleted',
      CHANGES_WILL_NOT_BE_SAVED: 'Changes won’t be saved if you made any',
      ACCESS_REVOKED: 'Access revoked',
      CASHIER_STATUS_INFO: 'Cashier needs to enter login and temporary password to access the app',
      CASHIER_STATUS_SUCCESS: 'Cashier is registered and can use the app',
      CONFIRM_CLOSE: {
        ADD_OUTLET: 'Sales point data will not be saved if entered',
        ADD_CASH: 'Register data will not be saved if entered',
        EDIT_CASH: 'Changes to the register will not be saved',
        ADD_CASHIER: 'Cashier data will not be saved if entered',
      },
      ACTION: {
        REVOKE: 'Revoke',
        COPY_LINK: 'Copy the link',
      },
    },
    MORE_OUTLETS: 'more points | {count} point | {count} points | {count} points',
    MORE_EMPLOYEES: 'more employees | {count} employee | {count} employees | {count} employees',
    MORE_CASHES: 'more registers | {count} register | {count} registers | {count} registers',
    MORE_CASHES_PREFIX: 'more registers | {count} register | {count} registers | {count} registers',
    DETAILS: {
      SALES: 'Sales',
      CASH_REGISTERS: 'Cash registers',
      ABOUT_POINT: 'About the point',
      LIST_QR: 'QR list',
    },
    EMPLOYEE: {
      TITLE: 'New cashier',
      ACCESS_OTHER_CASH: 'Grant access to other registers',
      INFO_SUBTITLE: 'Enter cashier information',
      ACCESS_SUBTITLE: 'Which registers should be accessible?',
      ACCESS_SELECTED_CASH: 'Which cashiers should get access?',
      NOT_FOUND: 'No Optima client found with this TIN',
      ALREADY_ACTIVE: 'A cashier with this TIN already exists',
      DID_NOT_SELECTED: 'Select at least one register',
      SELECT_ALL: 'Select all registers',
      CASH_NUMBER: 'Register number',
      ADD_MORE: 'Add more cashiers',
      TO_LIST: 'To cashier list',
      MUST_ENTER_LOGIN_PASSWORD: '{name} must enter login and temporary password to access the app',
      EMPLOYEE_WITH_ACCESS: 'Cashiers with access',
      FIRST_OR_SECOND_NAME: 'First or last name',
      ABOUT_EMPLOYEE: 'About the cashier',
      CASHES: 'Registers',
      QR_ADD: 'Generate a QR code',
      INN_ADD: 'Add by INN',
    },
    STATUS: {
      INIT: 'Login credentials sent',
      CONFIRM: 'Added',
      ON_VERIFICATION: 'Under consideration',
      DECLINED: 'Rejected',
      APPROVED: 'Accepted',
    },
    BANNER: {
      TITLE: 'Added all points of sale to one location',
      DESCRIPTION: 'Now you can view full information about terminals and QR payments',
    },
    HISTORY_INVITED: 'Application history',
    APPROVED_CASHIER: '"{name}" has been added to your company',
    DECLINED_CASHIER: 'The application of "{name}" has been canceled',
    CANCEL_CASHIER: 'Cancel the application of the cashier "{name}"?',
    NOT_CANCEL: 'No, do not cancel',
    YES_CANCEL: 'Yes, cancel',
    ACCEPTED: 'Adopted by {name}',
    REJECTED: 'Rejected by {name}',
    APPLICATION_SENT_TO_MANAGER: 'The application has been sent\nto the manager',
    INVITED: 'Invited',

    PAYMENT_FOR: 'Payment for: {name}',
    LAST_PAYMENT: 'Last payment',
    NO_FIRST_PAYMENT: 'The user has not yet made the first payment',
    QR_SORT_BY_DATE: 'By QR creation date',
    QR_SORT_NEW: 'New',
    QR_SORT_OLD: 'Old',
    ENTER_PURPOSE: 'Enter purpose',
    LAST_TRANSACTION_DATE_TIME: 'By the last payment',
    NO_PERSONAL_QR: 'You have no generated personal QR codes',
    AMOUNT_EDITING: 'Editing the amount',
    AMOUNT_EDITING_DENIED: 'Not allowed',
    AMOUNT_EDITING_ALLOWED: 'Allowed',
    PERSONAL_QR_UPDATED:
      'After editing, the data and amount of the personal QR code are updated. Save the updated QR code and print or download it again.',
  },
  INSTALLMENT: {
    TITLE: 'Installment sales',

    TABS: {
      HISTORY: 'History',
      OUTLET: 'Points',
      ABOUT: 'About products',
    },
    FILTER: {
      THREE: 'In 3 days',
      WEEK: 'In a week',
      MONTH: 'In 30 days',
    },
    STATUS: {
      ALL: 'All',
      UNDER_REVIEW: 'In process',
      AWAITING_DELIVERY_OF_GOODS: 'Waiting for confirmation',
      CREDITING_FUNDS: 'Transferring money to your account',
      ISSUED: 'Done',
      REFUSED: 'Rejected',
      ACTIVE: 'Active',
      NON_ACTIVE: 'Not active',
      IN_PROCESS: '@:INSTALLMENT.STATUS.UNDER_REVIEW',
      ACCEPTED: '@:INSTALLMENT.STATUS.AWAITING_DELIVERY_OF_GOODS',
      PROCESSED: '@:INSTALLMENT.STATUS.ISSUED',
      REJECTED: '@:INSTALLMENT.STATUS.REFUSED',
      ERROR: 'Error',
    },
    FILL_FIELD: 'Enter the reason for cancellation',
    INCOMING_FOR: 'Revenue in last {day} day',
    CONNECT: 'Add {product}',
    EMPTY: 'Nothing found',
    PERIOD: 'Action period',
    PERIOD_INFO:
      'Acceptance of installment payments is automatically extended. If you want to disable it, contact the bank',
    TERM_COMMISSION: 'Period and commission',
    CONTACT_INFO: 'Contact info',
    CONTACT_PERSON: 'Contact person',
    MY_CATEGORY: 'My category',
    GO_TO_SALES: 'To the sales',
    EMAIL: 'Email',
    TRY_AGAIN: 'Try again',
    TO_SALE_LIST: 'To the sales list',
    CONFIRM_SALE: 'Confirm the sale',
    SALE_REJECT: 'Sale rejected',
    SALE_CONFIRMED: 'Sale confirmed',
    SALE: 'Sale',
    DETAILS: 'Details',
    CONTRACT_NUMBER: 'Contract number',
    REPAYMENT_PERIOD: 'Repayment period',
    CUSTOMER: 'Customer',
    REJECT_TITLE: 'Why do you want to reject it?',
    REJECT_SALE: 'Reject the sale',
    PLACEHOLDER_REJECT: 'I do not issue this product in installments',
    REJECT_REASON: 'Reason for rejection',
    MONTH: 'mon.',
    ADDRESS: 'Address of the bank office',
    PROFIT_ALL_TIME: 'Income for all time',
    FROM:
      '<span class="entity-installment-product-card__label">From</span>\n' +
      '          <span class="entity-installment-product-card__value">{date}</span>',
    TO:
      '<span class="entity-installment-product-card__label">To</span>\n' +
      '          <span class="entity-installment-product-card__value">{date}</span>',
    ONBOARDING: {
      TO_SALE: 'Back to Products',
      PAY_DA: {
        TITLE_PRODUCT: 'Increase sales with ПАЙДА!',
        TITLE_BANK: 'Contact the office of the bank where you opened the current account',
        DESCRIPTION_CONNECT: "Don't forget to bring your passport. We'll set up ПАЙДА! payments — it won't take long",
        DESCRIPTION_MONEY: 'You get paid in full right away, and the buyer pays the bank over time',
        DESCRIPTION_SALE: 'You will be able to increase sales and average check',
        DESCRIPTION_QR: 'Payment by QR code at the point of sales',

        BUTTON_GET_CASH: 'I want more sales',
        SEND_APPLICATION_TO_CONNECT: 'Request connection',
        CONTACT_NAME: 'Name',
        SEND_APPLICATION: 'Submit request',
        APPLICATION_SENT: 'Request sent',
        APPLICATION_SENT_HINT: 'We’ll call you soon to discuss the details',

        CREATE_OUTLET: 'Create a point of sale now',
        CREATE_OUTLET_LATER: 'Create later',
        CREATE_DESCRIPTION: 'To sell via ПАЙДА! there has to be a point of sale - you may create it now',
      },
      TEZ_CREDIT: {
        TITLE_PRODUCT: 'Sell with TEZ Installments',
        TITLE_BANK: 'Contact the office of the bank where you opened the current account',
        DESCRIPTION_CONNECT:
          "Don't forget to bring your passport. We'll set up TEZ Installments payments — it won't take long",
        DESCRIPTION_MONEY: 'You get paid in full right away, and the buyer pays the bank over time',
        DESCRIPTION_SALE: 'You will be able to increase sales and average check',
        DESCRIPTION_QR:
          'The customer scans the QR code at your sales point to apply for installments, and you simply confirm the delivery',
        BUTTON_GET_CASH: 'How to start selling',
      },
    },
  },
  NPT: {
    BANNER: {
      TITLE: 'Pay off your tax debt to make transfers!',
      DESCRIPTION: 'Contact the bank office where you opened your current account',
    },
    DIALOG: {
      TITLE: 'Tax debts',
      DEBT: 'Debt  {number}',
      PAYMENT_REQUEST: 'Налоговое платежное требование',
      NOTICE: 'Извещение',
    },
  },
  INVOICE: {
    LIST_TITLE: 'Invoices',
    TITLE: 'Invoice',
    DIALOG: {
      CONFIRM_CLOSE: {
        LABEL: 'The invoice draft will not be saved',
      },
    },
    ISSUE: 'Issue an Invoice',
    INCOMING: 'Incoming',
    OUTGOING: 'Outgoing',
    PRODUCT: 'Products and Services',
    ALLOW_PARTIAL_PAYMENT: 'Allow partial payment',
    MOBILE_TABS: {
      INVOICES: 'Invoices',
      CATALOG: 'Catalog',
    },
    OPEN_INVOICE: 'Open Invoice',
    AVAILABLE_AROUND_THE_CLOCK: 'Service available 24/7',
    PAYMENT_AMOUNT: 'Payment amount',
    CREATED_AT: 'Created',
    EXPIRES_AT: 'Invoice Expiration Date',
    IN_PROGRESS: 'In Progress',
    PAY: 'Pay',
    REJECT: 'Reject',
    ISSUED_INVOICE: 'Issued invoice',
    INVOICE_PAYMENT: 'Invoice payment',
    INTRABANK_TRANSFER_BY_INVOICE: 'Intrabank transfer based on invoice',
    PRODUCTS_MORE: '+ {count} products',
    EMPTY_CATALOG:
      'There are no products or services in the catalog yet\nCreate your first item and use it when issuing invoices',
    EMPTY_OUTGOING:
      'You don’t have any outgoing invoices yet.\nCreate your first invoice to request payment for goods or services.',
    EMPTY_OUTGOING_ACTION: 'Create invoice',
    EMPTY_INCOMING:
      'You don’t have any incoming invoices yet.\nInvoices issued to you by other companies will appear here.',
    COUNTERPARTY: {
      SUPPLIER: 'Supplier',
      BUYER: 'Buyer',
    },
    TYPE_SHORT: {
      INDIVIDUAL: 'for Individual',
      LEGAL: 'for Legal Entity',
    },
    TYPE_FULL: {
      INDIVIDUAL: 'Invoice for Individual',
      LEGAL: 'Invoice for Legal Entity',
    },
    TYPE_MOBILE: {
      INDIVIDUAL: 'Invoice for Individual',
      LEGAL: 'Invoice for Legal Entity',
    },
    TYPE_FILTER: {
      TITLE: 'Invoice type',
      LEGAL: 'Legal Entity / SP',
      INDIVIDUAL: 'Individual',
    },
    SERVICE_DIALOG: {
      TRIGGER: 'Service terms and features',
      TITLE: 'Service terms and features',
      DESCRIPTION:
        'The invoicing service allows you to quickly receive payments for goods and services — within Optima Bank and from other banks',
      INDIVIDUAL_DESCRIPTION:
        'Invoices for individuals allow you to quickly receive payments for goods and services within Optima Bank.',
      TARIFFS_TITLE: 'Fees / Tariffs',
      FOR_SOLE_PROPRIETORS: 'For sole proprietors',
      FOR_LEGAL_ENTITIES: 'For legal entities',
      INTERNAL_BANK_LABEL: 'within Optima Bank',
      OTHER_BANKS_LABEL: 'from other banks',
      SOLE_INTERNAL_VALUE: '0.8%',
      SOLE_OTHER_VALUE: '1%',
      LEGAL_INTERNAL_VALUE: '1%',
      LEGAL_OTHER_VALUE: '1%',
      TARIFFS_NOTE: 'Individual tariffs may apply for certain clients',
      FEATURES_TITLE: 'Features',
      FEATURE_1: 'Issuing invoices within the bank and to other banks',
      FEATURE_2: 'Instant crediting of funds',
      FEATURE_3: 'Automatic payment status updates',
      FEATURE_4: 'Service available 24/7',
      FEATURE_5: 'Integration with 1C',
      ACTION: 'Go Back',
    },
    STATUS_INFO_DIALOG: {
      REJECTED_TITLE: 'Rejected status',
      REJECTED_DESCRIPTION: 'Payer refused to pay the invoice.',
      CANCELLED_TITLE: 'Cancelled status',
      CANCELLED_DESCRIPTION: 'Invoice cancelled by issuer before payment.',
      EXPIRED_TITLE: 'Expired status',
      EXPIRED_DESCRIPTION: 'Payment period expired. Invoice is no longer valid.',
      BACK: 'Go Back',
    },
    COUNT_WIDGET: {
      TITLE: 'You have {count} incoming invoice',
      ACTION: 'Go to Invoice',
    },
    PRODUCTS_TABLE: {
      SEARCH_PLACEHOLDER: 'Search',
      ADD_BUTTON: 'Add Product or Service',
      ADD_TITLE: 'Add Product or Service',
      CODE: 'Code',
      NAME: 'Name',
      UNIT: 'Unit',
      QUANTITY: 'Quantity',
      PRICE: 'Price with taxes',
      TAXES: 'Taxes',
      ACTIONS: 'Actions',
      DELETE_TITLE: 'Delete product?',
      DELETE_MESSAGE: 'Product data “{name}” will not be saved',
      SAVED_TITLE: 'Changes saved',
      PRODUCT_SAVED_TITLE: 'Product saved to catalog',
      EDIT_TITLE: 'Edit',
      NAME_LABEL: 'Name',
      PRICE_LABEL: 'Price with taxes',
      UNIT_LABEL: 'Unit of measure',
      VAT_LABEL: 'VAT, %',
      SALES_TAX_LABEL: 'Sales Tax, %',
      VAT_RATE: 'VAT',
      SALES_TAX_RATE: 'Sales Tax',
      AMOUNT: 'Amount',
      EMPTY: 'No products/services yet',
      CANCEL_TITLE: 'Do not add product?',
      CANCEL_MESSAGE: 'Data will not be saved if you entered it',
    },
    CREATE_PARAMS_TITLE: 'Invoice Parameters',
    CREATE_RECIPIENT_TITLE: 'Invoice Recipient',
    PRODUCTS_TABLE_LIMIT_HINT:
      'Up to {count} goods and/or services can be added to an invoice, with a total amount of up to {sum} KGS',
    CASH_NUMBER_LABEL: 'Cash desk number',
    ACCOUNT_NUMBER_LABEL: 'Invoice number',
    ACCOUNT_NUMBER_AUTO_HINT: 'If the account number is not specified, it will be assigned automatically',
    VALIDITY_PERIOD_LABEL: 'Validity period',
    VALIDITY_EXPIRES_AT_HINT: 'Invoice Expiration Date: {date}',
    ACCOUNT_NUMBER: 'Invoice No.',
    VALIDITY_DAYS: 'Invoice Validity Period (days)',
    VALIDITY_DAYS_HINT: 'If left empty or 0, the invoice will be valid until 23:59',
    VALIDITY_DAYS_RANGE: 'Enter a value from 0 to 30',
    SALE_POINT_ACCOUNT: 'Funds will be credited to the account - {account}',
    RECIPIENT_NAME_INN: 'Recipient name / TIN',
    RECIPIENT_SEARCHING: 'Searching recipients…',
    PURPOSE_COMMENT: 'Purpose / Comment',
    PURPOSE_PAYMENT_HINT: 'Specify the payment purpose: what or for whom the payment is for',
    CONTINUE: 'Continue',
    STEPS: {
      REQUISITES: 'Payment Details / Bank Details',
      PRODUCTS: 'Goods and/or services',
    },
    CREATE_INDIVIDUAL: 'Invoice for Individual',
    CREATE_LEGAL: 'Invoice for Legal Entity',
    CONFIRM_ISSUE_TITLE: 'Invoice has been created.',
    CONFIRM_ISSUE_MESSAGE: 'Choose sending method',
    CONFIRM_ISSUE_ACTION: 'Send via Optima Business',
    SEND_MYSELF_ACTION: 'Send manually',
    DOWNLOAD_TITLE: 'Download',
    DOWNLOAD: 'Download',
    BACK_TO_EDIT: 'Return to Editing',
    HINT: 'Invoice can only be issued to an Optima24 user',
    SUCCESS_SEND: 'Invoice successfully sent',
    SUCCESS_HINT: 'You can track the invoice status in the "Invoices" section, under the "Outgoing" tab',
    SUCCESS_HINT_CASH: 'Track the operation status in “Sales” of {salePoint}',
    PDF_DOWNLOADED_TITLE: 'The PDF invoice has been uploaded',
    PDF_DOWNLOADED_HINT:
      'Send the invoice to the payer in any convenient way. You can track the payment in the “Outgoing” tab.',
    PDF_DOWNLOADED_ACTION: 'Back to Invoices',
    DRAFT_SAVED_TITLE: 'Invoice saved as draft',
    DRAFT_SAVED_HINT: 'You can find it in the "Invoices" section under the "Draft" tab',
    TO_INVOICES: 'Back to Invoices',
    TO_SIGN: 'For signing',
    SEND_INVOICE: 'Issue an Invoice',
    REVOKED: 'Invoice revoked',
    REJECT_QUESTION: 'Reject the invoice?',
    RECALL_QUESTION: 'Recall the invoice?',
    REJECT_SUCCESS: 'Invoice Rejected',
    EMPTY_SALE_POINT: 'To issue an invoice for payment, add a point of sale',
    ASK_SALE_POINT: 'To issue an invoice for payment, ask your manager to add a point of sale',
    STATUS: {
      WAITING: 'Waiting',
      PAID: 'Paid',
      EXPIRED: 'Expired',
      CANCELLED_BY_SENDER: 'Revoked',
      REJECTED_BY_PAYER: 'Cancelled',
    },
    RULES: {
      MAX_SUM: 'The payment amount cannot be more than {sum} soms',
    },
    OUTGOING_STATUS: {
      ALL: 'All',
      ISSUED: 'Issued',
      PAID: 'Paid',

      PARTIALLY_PAID: 'Partially paid',
      REJECTED: 'Rejected',
      CANCELLED: 'Cancelled',
      EXPIRED: 'Expired',
      DRAFT: 'Draft',
      TITLE: 'Invoice',
      LEGAL_ENTITY: 'to legal entity',
      BUYER_NAME: 'Buyer name',
      COMMENT: 'Invoice comment',
    },
    INCOMING_STATUS: {
      ALL: 'All',
      ISSUED: 'Issued',
      PAID: 'Paid',

      PARTIALLY_PAID: 'Partially paid',
      REJECTED: 'Rejected',
      CANCELLED: 'Cancelled',
      EXPIRED: 'Expired',
      TITLE: 'Invoice',
      LEGAL_ENTITY: 'to legal entity',
      SELLER_NAME: 'Seller name',
      COMMENT: 'Invoice comment',
    },
    OUTGOING_FILTER: {
      BUYER_NAME: 'Buyer name',
      SORT_AMOUNT: 'Amount',
      SORT_AMOUNT_ASC: 'Ascending',
      SORT_AMOUNT_DESC: 'Descending',
    },
    INCOMING_FILTER: {
      SELLER_NAME: 'Seller name',
      SORT_AMOUNT: 'Amount',
      SORT_AMOUNT_ASC: 'Ascending',
      SORT_AMOUNT_DESC: 'Descending',
    },
    DETAILS: {
      PURPOSE: 'Purpose / Comment',
      OPEN: 'Open Invoice',
      INVOICE_NUMBER: 'Invoice No.',
      EXPIRES_AT: 'Invoice Expiration Date',
      CREATED_BY: 'Created by',
      INVOICE_TYPE: 'Payer type',
      INVOICE_TYPE_INTERNAL: 'Intrabank',
      INVOICE_TYPE_EXTERNAL: 'Interbank',
      BUYER_TITLE: 'Counterparty',
      BUYER_LABEL: 'TIN/Name',
      PRODUCTS: 'Products/Services',
    },
  },
  USER_APPROVE: {
    APPROVE_ACCOUNT: 'Confirm your account in the bank office to access all services',
    APPROVE_ACCOUNT_SHORT: 'Confirm your account',
    APPROVE_ACCOUNT_FOR_OPERATIONS: 'Confirm your account in the bank office to get full access to transactions',
    ACCOUNT_NOT_APPROVE: 'Account is not verified',
    CREDIT: {
      TITLE: 'Loans and Installment products',
      DESCRIPTION: 'Get loans and installment products',
    },
    TRANSFER: {
      TITLE: 'Transfers to other banks',
      DESCRIPTION: 'Make payments to partners without restrictions',
    },
    LIMITS: {
      TITLE: 'Extended limits',
      DESCRIPTION: 'Send large payments without any limits*',
    },
    LIMIT_TRANSFER: {
      TITLE: '* Limits for internal transfers:',
      ONE_OPERATION: '• Per operation — up to 200,000 KGS',
      MONTH_OPERATION: '• Per month — up to 400,000 KGS',
    },
  },
  BANK_OFFICES: {
    TITLE: 'Branch map',
    SEARCH_PLACEHOLDER: 'Enter branch address',
    EMPTY: 'No branches found',
  },
  REQUISITES: {
    TITLE: 'Requisites',
    COMPANY_NAME: 'Company name',
    LEGAL_ADDRESS: 'Legal address',
    INTERMEDIARY_BANK: 'INTERMEDIARY BANK',
    SWIFT: 'SWIFT',
    INN: 'TIN',
    STIN: 'TIN',
    TIN: 'TIN',
    CORRESPONDENT_ACCOUNT: 'Correspondent account',
    IBAN: 'IBAN',
    IKK: 'IKK',
    BIN: 'BIN',
    CNAPS: 'CNAPS code',
    ACCOUNT_NO: 'Account number',
    LOCAL_BIC: 'Local bank ID',
    SWIFT_BIC: 'International swift/BIC code of the bank',
    ROUTING_NUMBER: 'Routing number (ABA)',
    KBE: 'The code of the budget unit used for payments in Kazakhstan',
    INFO: 'Additional information',
    BENEFICIARY_BANK: 'Beneficiary Bank',
    PURPOSE: 'Purpose of payment (140 characters limit)',
    PDF: 'Export to PDF',
    COPY: 'Copy the details',
    INFO_ACCOUNT: 'Account info',
    HISTORY: 'History',
  },
};
